import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { DateRange, MatCalendar } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import moment, { Moment } from 'moment';
import { DateAdapter } from '@angular/material/core';
declare var $: any;
import { UIChart } from 'primeng/chart';
import { BsDatepickerConfig, BsDatepickerDirective, BsDatepickerViewMode } from 'ngx-bootstrap/datepicker';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexGrid, ApexLegend, ApexPlotOptions, ApexStroke, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductivityDashboardService } from './productivity-dashboard.service';
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  tooltip: ApexTooltip;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
  stroke: ApexStroke;
};
@Component({
    selector: 'app-productivity-dashboard',
    templateUrl: './productivity-dashboard.component.html',
    styleUrls: ['./productivity-dashboard.component.scss'],
    standalone: false
})
export class ProductivityDashboardComponent implements OnInit, AfterViewInit {
  bucketurl = environment.bucketUrl;
  stageIds: any = environment.salesDashboardId;
  selectedButton: any = 'custom';
  isLoading: Subject<boolean> = new Subject<boolean>();
  duration: any = 1500;
  @ViewChild('dateRangePicker') dateRangePickerTemplate!: TemplateRef<any>;
  @ViewChild('cancelButton') cancelButton!: ElementRef;
  @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
  @ViewChild('dpCategoryStart', { static: true }) dpCategoryStart!: BsDatepickerDirective;
  @ViewChild('dpCategoryEnd', { static: true }) dpCategoryEnd!: BsDatepickerDirective;
  @ViewChild('dpModelStart', { static: true }) dpModelStart!: BsDatepickerDirective;
  @ViewChild('dpModelEnd', { static: true }) dpModelEnd!: BsDatepickerDirective;
  @ViewChild('dpSourceStart', { static: true }) dpSourceStart!: BsDatepickerDirective;
  @ViewChild('dpSourceEnd', { static: true }) dpSourceEnd!: BsDatepickerDirective;
  public headerCards: any = []
  public cards: any = [{ title: 'All Leads', value: '2047', icon: 'leads_dash.png' }, { title: 'Test ride', value: '2047', icon: 'test_ride_dash.png' }, { title: 'Enq. to Test Ride', value: '2047', icon: 'enq_ride_dash.png' }, { title: 'Enq. to Booked', value: '2047', icon: 'enq_to_booked_dash.png' }, { title: 'Enq. to Retailed', value: '2047', icon: 'enq_to_retailed_dash.png' }]

  today: Date = new Date(); // Initialize today's date
  startDate: any;
  endDate: any;
  // Set the range
  range: { start: Date | null; end: Date | null } = {
    start: moment().endOf('month').subtract(1, 'week').toDate(),
    end: moment().endOf('month').add(1, 'week').toDate()
  };

  // DateRange instance using range
  dateRange = new DateRange(this.range.start, this.range.end);
  @ViewChildren(UIChart) chartComponents!: QueryList<UIChart>;  // Access all chart components
  @ViewChild("chart", { static: false }) chart!: ChartComponent;
  dropdownData: any = [];
  categoryData: any = [];
  modelsData: any = [];
  sourceData: any = [];
  userData: any = [];

  // Geography Status Box Data
  geographyStatus: any = [];
  categoryStatus: any = [
    { name: 'Big Bikes', leads: 0, count: 0 },
    { name: 'Scooters', leads: 0, count: 0 },
    { name: 'Motorcycles', leads: 0, count: 0 },
    { name: 'Not Mapped', leads: 0, count: 0 },
  ];
  modelStatus: any = [];
  sourceStatus: any = [];
  sourceList: any = [];
  filteredDataSource: any = [...this.sourceList]; // Initialize filtered data
  geographyToggle: any = [{ id: 2, name: 'Unique Test Ride', checked: false }, { id: 9, name: 'Booked', checked: false }, { id: 10, name: 'Retailed', checked: true }];
  categoryToggle: any = [{ id: 2, name: 'Unique Test Ride', checked: false }, { id: 9, name: 'Booked', checked: false }, { id: 10, name: 'Retailed', checked: true }];
  modelToggle: any = [{ id: 2, name: 'Unique Test Ride', checked: false }, { id: 9, name: 'Booked', checked: false }, { id: 10, name: 'Retailed', checked: true }];
  sourceToggle: any = [{ id: 2, name: 'Unique Test Ride', checked: false }, { id: 9, name: 'Booked', checked: false }, { id: 10, name: 'Retailed', checked: true }];
  public productCategoryOptions: any;
  public productModelOptions: any;
  public sourceOptions: any;
  public subSourceOptions: any;
  selectedCardIndex: any = -1;
  zoneSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'zone_id',
    textField: 'Zone_Manager',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  regionSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'outlet_id',
    textField: 'username',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  areaSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'outlet_id',
    textField: 'username',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  zonalList: any = [];
  regionalList: any = [];
  areaList: any = [];
  constructor(public dialog: MatDialog, private toastr: ToastrService, private _dateAdapter: DateAdapter<Moment>, private cdr: ChangeDetectorRef, private productivityService: ProductivityDashboardService) {
    this.productCategoryOptions = {
      series: [
        {
          name: 'Enquiries',
          data: [],
        }
      ],
      chart: {
        height: 280,
        type: "bar",
        events: {
          click: function (chart: any, w: any, e: any) {
          },
        },
        toolbar: {
          show: false
        }
      },
      colors: ["#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6"],
      plotOptions: {
        bar: {
          columnWidth: "45px",
          distributed: true,
          dataLabels: {
            position: 'top',
            style: {
              fontSize: '12px',
              color: ['#000000', '#000000'], // Assign white for 1st series, black for 2nd
            },
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        show: true,
        markers: {
          strokeWidth: 0, // No border
          shape: 'circle'
        },
        onItemClick: {
          toggleDataSeries: true  // Enables toggling of the series when the legend is clicked
        },
        onItemHover: {
          highlightDataSeries: true
        }
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      xaxis: {
        categories: [],

        labels: {
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0  // Ensure the y-axis starts from 0
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };

    this.productModelOptions = {
      series: [
        {
          name: 'Enquiries',
          data: [],
        }
      ],
      chart: {
        height: 280,
        type: "bar",
        events: {
          click: function (chart: any, w: any, e: any) {
          },
        },
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      colors: [
        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",   // Original colors
        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",   // First additional set
        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366"               // New additional colors
      ],
      plotOptions: {
        bar: {
          columnWidth: "45px",
          distributed: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        show: true,
        onItemClick: {
          toggleDataSeries: true,  // Enables toggling of the series when the legend is clicked
        },
        markers: {
          strokeWidth: 0, // No border
          shape: 'circle'
        },
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      xaxis: {
        categories: [],
        range: 5,
        labels: {
          rotate: 0,
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '11px'
          },
        }
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0  // Ensure the y-axis starts from 0
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };

    this.sourceOptions = {
      series: [
        {
          name: 'Enquiries',
          data: [],
        }
      ],
      chart: {
        height: 280,
        type: "bar",
        events: {
          click: function (chart: any, w: any, e: any) {
          },
        },
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      colors: ["#52A0FB", "#8D8D8D"],
      plotOptions: {
        bar: {
          columnWidth: "40px",
          distributed: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        show: true,
        markers: {
          strokeWidth: 0, // No border
          shape: 'circle'
        },
        onItemClick: {
          toggleDataSeries: true,  // Enables toggling of the series when the legend is clicked
        }
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      xaxis: {
        categories: [['Organic'], ['Walk-In']],

        labels: {
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0  // Ensure the y-axis starts from 0
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };

    this.subSourceOptions = {
      noData: {
        text: 'No Data',
      },
      series: [
        {
          name: 'Enquiries',
          data: [],
        }
      ],
      chart: {
        height: 280,
        type: "bar",
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#333']
        },
        offsetY: -20
      },
      colors: [
        "#87C472", // Green
        "#F9729F", // Pink
        "#65C4D9", // Cyan
        "#CC8CEB", // Light Purple
        "#7DA9EB", // Sky Blue
        "#FFB84D", // Golden Yellow
        "#FF6F61", // Coral Red
        "#A66C9D", // Muted Lavender
        "#6B8E23", // Olive Green
        "#FFA07A"  // Light Salmon
      ],
      plotOptions: {
        bar: {
          columnWidth: "45px",
          distributed: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      legend: {
        position: 'top',
        markers: {
          shape: 'circle'
        },
        onItemClick: {
          toggleDataSeries: true
        },
        onItemHover: {
          highlightDataSeries: true
        },
        horizontalAlign: 'left',
        show: true
      },
      grid: {
        borderColor: '#D9D9D9',
        strokeDashArray: 3,
      },
      xaxis: {
        categories: [],

        labels: {
          rotate: 0,
          style: {
            // colors: ['#1890FF','#1890FF','#1890FF','#1890FF','#1890FF'],
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        max: function (max: any) {
          return Math.ceil(max * 1.1); // Round up to ensure integer values
        },
        min: 0  // Ensure the y-axis starts from 0
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
    };
  }


  selectedZone: any = {}
  totalLeads: any = 0;
  totalLeadsInZones: any = 0
  selectCard(index: number, zone: any) {
    if (index != this.selectedCardIndex) {
      this.selectedCardIndex = index; // Update the selected index
      this.selectedZone = zone; // Update the selected zone
      this.totalLeads = zone.value
      this.getStageWiseCounts();
    } else {
      this.selectedCardIndex = -1; // Reset the selected index
      this.selectedZone = {}; // Reset the selected zone
      this.totalLeads = this.totalLeadsInZones
      this.getStageWiseCounts();
    }
  }

  openDateRangePicker() {
   const dialogRef:any = this.dialog.open(this.dateRangePickerTemplate, { panelClass: 'modal-picker-class' });
   dialogRef.afterOpened().subscribe(() => {
    if (this.startCalendar) {
      const selectMonth = new Date(this.startDate);
      this.startCalendar.activeDate = selectMonth;
    }
  });
    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.nativeElement.focus();
      }

    }, 300);
  }


  selectToday() {
    const today = new Date();
    this.startDate = today;
    this.endDate = today;
    this.selectedButton = 'today';

    this.dateRange = new DateRange(this.startDate, this.endDate);
    const selectMonth = new Date();
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

  selectLast7Days() {
    const today = new Date();

    // Exclude today: Start from yesterday
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - 6); // 7 days excluding today

    this.endDate = yesterday; // Yesterday is the end date

    this.selectedButton = 'last7';

    this.dateRange = new DateRange(this.startDate, this.endDate);


    const selectMonth = new Date(this.startDate);
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }

  selectLast15Days() {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Set start date as 7 days before yesterday
    this.startDate = new Date(yesterday);
    this.startDate.setDate(yesterday.getDate() - 14);

    this.endDate = yesterday;
    this.selectedButton = 'last15';
    this.dateRange = new DateRange(this.startDate, this.endDate);

    const selectMonth = new Date(this.startDate);
    selectMonth.setMonth(selectMonth.getMonth());
    if (this.startCalendar) {
      this.startCalendar.activeDate = selectMonth;
    }
  }


 selectThisMonth() {
   this.selectedButton = 'thisMonth';
   const today = new Date();
 
   let startOfMonth: Date;
   let endOfMonth: Date;
 
   if (today.getDate() === 1) {
     // If today is the 1st, use last month's full range
     const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
     startOfMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
     endOfMonth = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0); // Last day of last month
   } else {
     // Regular case: current month start to yesterday
     startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
     endOfMonth = new Date(today);
     endOfMonth.setDate(today.getDate() - 1);
   }
 
   this.startDate = startOfMonth;
   this.endDate = endOfMonth;
   this.dateRange = new DateRange(this.startDate, this.endDate);
 
   // Keep the month selection in the calendar
   const selectMonth = new Date(this.startDate);
   if (this.startCalendar) {
     this.startCalendar.activeDate = selectMonth;
   }
 }
 

  selectCustom() {
    this.selectedButton = 'custom';
    this.startDate = null;
    this.endDate = null;
    this.dateRange = new DateRange(this.startDate, this.endDate);
  }

  onStartDateChange(event: Date) {
    this.startDate = event;
  }

  onEndDateChange(event: Date) {
    this.endDate = event;
  }


  closeDialog() {
    if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
      this.toastr.error("The end date should be greater than or equal to the start date!")
    } else {
      this.dialog.closeAll();
      this.selectThisMonth();
      setTimeout(() => {
        this.applyDateRange();
      }, 100)
    }
  }

  isGlobalDateCategory: boolean = true;
  applyDateRange() {
    // Logic to apply the date range
    if (this.startDate == null || this.endDate == null) {
      this.toastr.error("Please select a date range!");
    } else {
      if (moment(this.startDate).format('YYYY-MM-DD') > moment(this.endDate).format('YYYY-MM-DD')) {
        this.toastr.error("The end date should be greater than or equal to the start date!")
      } else {
        this.dialog.closeAll();
        this.isGlobalDateCategory = true;

        /** clearing category*/
        this.visibleCategoryMonth = false;
        // Reset bsValue of dp1 and dp2 to undefined
        if (this.dpCategoryStart) {
          this.dpCategoryStart.bsValue = undefined;
        }
        if (this.dpCategoryEnd) {
          this.dpCategoryEnd.bsValue = undefined;
        }

        // Clear any selected start and end dates
        this.categoryStartMonth = undefined;
        this.categoryEndMonth = undefined;


        /** clearing Model*/
        this.visibleModelMonth = false;
        // Reset bsValue of dp1 and dp2 to undefined
        if (this.dpModelStart) {
          this.dpModelStart.bsValue = undefined;
        }
        if (this.dpModelEnd) {
          this.dpModelEnd.bsValue = undefined;
        }

        // Clear any selected start and end dates
        this.modelStartMonth = undefined;
        this.modelEndMonth = undefined;

        this.visibleSourceMonth = false;

        // Reset bsValue of dp1 and dp2 to undefined
        if (this.dpSourceStart) {
          this.dpSourceStart.bsValue = undefined;
        }
        if (this.dpSourceEnd) {
          this.dpSourceEnd.bsValue = undefined;
        }

        // Clear any selected start and end dates
        this.sourceStartMonth = undefined;
        this.sourceEndMonth = undefined;
        this.getZoneWiseCounts();
        this.getStageWiseCounts();
        // if (this.roleId == 8 || this.roleId == 9) {
        //   this.getParentDealerChartCounts();
        //   this.getPerformanceCountsByPD();
        // } else {
        this.getGeographyChartCounts();
        this.getPerformanceCounts();
        // }
        this.getCategoryChartCounts();
        this.getModelChartCounts();
        // this.getSourceChartCounts();
        this.getSubSourceChartCounts();
        /**to get table data */
        setTimeout(() => {
          // if (this.roleId == 8 || this.roleId == 9) {
          //   this.getParentDealerTableData();
          // } else {
          this.getGeographyTableData();
          // }
          this.getCategoryTableData();
          this.getModelTableData();
          this.getSourceTableData();
        }, 4000)
        let filterObject: any = {}
        if (sessionStorage.getItem('filterObject')) {
          filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
        }
        filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
        filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
        filterObject.selectedButton = this.selectedButton;
        sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
      }
    }
  }

  clearDate() {
    this.selectedButton = 'thisMonth';
    this.startDate = null;
    this.endDate = null;
    this.closeDialog();
  }
  loadingTable1 = true;
  loadingTable2 = true;
  loadingTable3 = true;
  loadingTable4 = true;
  regionData: any = []
  roleId: any = null;
  filterObject: any = {};
  isDateOne: boolean = false;

  ngOnInit() {
    if (this.today.getDate() == 1) {
      this.isDateOne = true
    } else {
      this.isDateOne = false
    }
    this.filterObject = {}
    if (sessionStorage.getItem('filterObject')) {
      this.filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      this.isActiveOutlet = this.filterObject.isActiveOutlet ? this.filterObject.isActiveOutlet : false;
      this.isOneOutlet = this.filterObject.isOneOutlet ? this.filterObject.isOneOutlet : false;
      if (this.filterObject.zonalManagers) {
        this.selectedZonalMgrs = this.filterObject.zonalManagers || [];
      }
      if (this.filterObject.regionalManagers) {
        this.selectedRegionalMgrs = this.filterObject.regionalManagers || [];
      }
      if (this.filterObject.areaManagers) {
        this.selectedAreaMgrs = this.filterObject.areaManagers || [];
      }
      if (this.filterObject.startDate) {
        this.startDate = new Date(this.filterObject.startDate);
        this.endDate = new Date(this.filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = this.filterObject.selectedButton;
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.roleId = loginResponse.data?.user?.role_id;
      }
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.bsConfig = {
      adaptivePosition: true,
      keepDatesOutOfRules: true,
      minMode: 'month' as BsDatepickerViewMode,
      dateInputFormat: 'MMMM YYYY',
      maxDate: new Date() // restricts to the current month
    };
    // this.selectThisMonth()
    if (this.roleId == 8 || this.roleId == 9 || this.roleId == 5 || this.roleId == 10) {
      this.getDealerOutletList();
    }
    this.getGeographyList();
    setTimeout(() => {
      // this.getStageWiseCounts();
      this.getSourceList();
      this.getUserList();
      this.getProductList();
      this.getZonalManager();
      this.getRegionalManager();
      this.getAreaManager();
    }, 1000)
    // setTimeout(() => {
    //     this.getGeographyChartCounts();
    //   this.getCategoryChartCounts();
    //   this.getModelChartCounts();
    //   this.getSubSourceChartCounts();
    //   if (this.roleId == 8 || this.roleId == 9 || this.roleId == 5 ||  this.roleId == 10 ) {
    //     if (this.roleId != 5 && this.roleId != 10) {
    //       // this.getParentDealerChartCounts();
    //     }
    //     this.getPerformanceCountsByPD();
    //   } else {
    //     this.getPerformanceCounts();
    //   }
    // }, 3500)

    // setTimeout(() => {

    //     this.getGeographyTableData();
    //   // }
    //   this.getCategoryTableData();
    //   this.getModelTableData();
    //   this.getSourceTableData();
    // }, 4000)
  }

  chartsData: any = []

  // Helper function to generate random colors for the chart
  getRandomColors(count: number): string[] {
    const colors: string[] = [];
    for (let i = 0; i < count; i++) {
      const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`; // Random Hex color
      colors.push(color);
    }
    return colors;
  }

  onZone() {
    this.isGeography = true;
    let isEveryRegion: boolean = this.regionData.every((object: any) => {
      return !object.states || object.states.length === 0;
    });
    /**
     * If all the regions is empty in all the zones, then show all the zones count in single pie chart
     */
    if (isEveryRegion) {
      // No regions, show all zones in one chart
      const zoneLabels = this.regionData.map((zone: any) => zone.zone_name);
      const zoneCounts = this.regionData.map((zone: any) => zone.count);
      const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: zoneLabels,  // Zone names as labels
          datasets: [
            {
              data: zoneCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: 'Enquiries' + ' - ' + totalCount,
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start',
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {
      let isEveryArea: boolean = this.regionData.every((object: any) => {
        return !object.states || object.states.length === 0;
      });

      this.regionData.forEach((zoneObj: any) => {
        const zoneName = zoneObj.zone_name;
        const zoneCount = zoneObj.count;

        if (zoneObj.states && zoneObj.states.length > 0) {
          // Zone has regions, create separate charts for each zone
          zoneObj.states.forEach((regionObj: any) => {
            const regionName = regionObj.state_name;
            const regionCount = regionObj.count;

            if (regionObj?.regions && regionObj?.regions.length > 0) {
              // Region has areas, show all areas in one chart
              const areaLabels = regionObj.regions.map((area: any) => area.region_name);
              const areaCounts = regionObj.regions.map((area: any) => area.count);

              const chartData = {
                zone: zoneName,
                region: regionName,
                data: {
                  labels: areaLabels,  // Area names as labels
                  datasets: [
                    {
                      data: areaCounts,  // Area counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(areaLabels.length)
                    }
                  ]
                },

                options: {
                  title: `${zoneName} - ${zoneCount}`,
                  subText1: ` ${regionName} - ${regionCount}`,
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);

                        // Return count and percentage on different lines
                        return `${value}\n ${percentage}%`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []
              filteredData = this.chartsData.filter((item: any) => item.region == chartData.region)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }
            } else {
              // Region has no areas, show all regions in one chart for the zone
              let isNoArea: boolean = zoneObj.states.every((item: any) => !item?.regions || item?.regions?.length === 0);
              let filteredDataNoArea = zoneObj.states.filter((item: any) => {
                return !item?.regions || item?.regions?.length == 0;
              });
              if (filteredDataNoArea.length != 0) {

                const regionLabels = filteredDataNoArea.map((region: any) => region.state_name);
                const regionCounts = filteredDataNoArea.map((region: any) => region.count);

                const chartData = {
                  zone: zoneName.toLowerCase(),
                  region: regionName.toLowerCase(),
                  data: {
                    labels: regionLabels,  // Region names as labels
                    datasets: [
                      {
                        data: regionCounts,  // Region counts
                        backgroundColor: [
                          // Original colors
                          "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                          // First additional set
                          "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                          // New additional colors
                          "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                          // Additional colors to reach 40
                          "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                          "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                          "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                          "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                          "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                        ],
                        // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                      }
                    ]
                  },
                  options: {
                    title: `${zoneName} - ${zoneCount}`,
                    subText1: '',
                    subText2: '',
                    cutout: '28%',
                    plugins: {
                      datalabels: {
                        color: '#fff',
                        display: true,
                        formatter: function (value: any, context: any) {
                          // Calculate percentage
                          const total = context.chart._metasets[context.datasetIndex].total;
                          const percentage = ((value / total) * 100).toFixed(0);

                          // Return count and percentage on different lines
                          return `${value}\n ${percentage}%`;
                        },
                        font: {
                          size: 9
                        },
                        anchor: 'end',
                        align: 'start'
                      },
                      legend: {
                        display: true,
                        labels: {
                          usePointStyle: true,
                          text: 'Zones'
                        }
                      }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                };
                let filteredData: any = []
                if (isNoArea) {
                  filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData.zone)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                } else {
                  filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone && item.region.toLowerCase() == chartData.region)
                  if (filteredData.length == 0) {
                    this.chartsData.push(chartData);
                  }
                }

              }
            }
          });
        } else {

          let filteredDataNoRegions = this.regionData.filter((item: any) => {
            return item?.states && item?.states?.length == 0;
          });
          const zoneLabels = filteredDataNoRegions.map((zone: any) => zone.zone_name);
          const zoneCounts = filteredDataNoRegions.map((zone: any) => zone.count);
          const totalCount = zoneCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: zoneLabels,  // Zone names as labels
              datasets: [
                {
                  data: zoneCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: 'Enquiries' + ' - ' + totalCount,
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item.zone.toLowerCase() == chartData.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  onPDChart() {
    this.isGeography = false;
    let isEveryOutlet: boolean = this.regionData.every((object: any) => {
      return !object.outlets || object.outlets.length === 0;
    });

    if (isEveryOutlet) {
      const dealerLabels = this.regionData.map((dealer: any) => dealer.parent_dealer_name);
      const dealerCounts = this.regionData.map((dealer: any) => dealer.count);
      const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: dealerLabels,  // Zone names as labels
          datasets: [
            {
              data: dealerCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: 'Enquiries' + ' - ' + totalCount,
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {

      this.regionData.forEach((dealerObj: any) => {
        const dealerName = dealerObj.parent_dealer_name;
        const dealerCount = dealerObj.count;

        if (dealerObj.outlets && dealerObj.outlets.length > 0) {
          dealerObj.outlets.forEach((ouletObj: any) => {
            const outletName = ouletObj.outlet_name;
            const outletCount = ouletObj.count;

            let filteredDataNoArea = dealerObj.outlets
            if (filteredDataNoArea.length != 0) {

              const outletLabels = filteredDataNoArea.map((outlet: any) => outlet.outlet_name);
              const outletCounts = filteredDataNoArea.map((outlet: any) => outlet.count);

              const chartData = {
                id:dealerObj.parent_dealer_id,
                zone: dealerName?.toLowerCase(),
                region: outletName?.toLowerCase(),
                data: {
                  labels: outletLabels,  // Region names as labels
                  datasets: [
                    {
                      data: outletCounts,  // Region counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                    }
                  ]
                },
                options: {
                  title: `${dealerName} - ${dealerCount}`,
                  subText1: '',
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);

                        // Return count and percentage on different lines
                        return `${value}\n ${percentage}%`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []

              filteredData = this.chartsData.filter((item: any) => item?.id == chartData?.id && item?.zone?.toLowerCase() == chartData?.zone)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }

            }

          });
        } else {

          let filteredDataNoOutlets = this.regionData.filter((item: any) => {
            return item?.outlets && item?.outlets?.length == 0;
          });
          const dealerLabels = filteredDataNoOutlets.map((dealer: any) => dealer.parent_dealer_name);
          const dealerCounts = filteredDataNoOutlets.map((dealer: any) => dealer.count);
          const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: dealerLabels,  // Zone names as labels
              datasets: [
                {
                  data: dealerCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: 'Enquiries' + ' - ' + totalCount,
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  // Private
  _startDate: any | null = null;
  _endDate: any | null = null;
  selectedChange(date: any): void {
    if (!this._startDate) {
      this._startDate = date;
    } else if (
      !this._endDate &&
      this._dateAdapter.compareDate(date, this._startDate) >= 0
    ) {
      this._endDate = date;
    } else {
      this._startDate = date;
      this._endDate = null;
    }
    this.dateRange = new DateRange(this._startDate, this._endDate);
    this.startDate = this._startDate;
    this.endDate = this._endDate;
  }

  @ViewChild('chartCarousel') chartCarousel!: ElementRef;
  ngAfterViewInit() {
    const nativeEl = this.chartCarousel.nativeElement;

    nativeEl.addEventListener('slid.bs.carousel', (e: any) => {
      console.log('>>> ', e.to);
      this.currentIndex = e.to;
    });
  }

  currentIndex = 0;
  totalSlides = 0
  nextSlide() {
    console.log("this.chartsData.length:",this.chartsData.length)
    const totalSlides = Math.ceil(this.chartsData.length / 2);
    this.totalSlides = totalSlides
    if (this.currentIndex < totalSlides  - 1) {
      $('#chartCarousel').carousel('next');
    }
  }
  
  prevSlide() {
    const totalSlides = Math.ceil(this.chartsData.length / 2);
    if (this.currentIndex > 0) {
      $('#chartCarousel').carousel('prev');
    }
  }

  visibleCategoryMonth: boolean = false
  visibleModelMonth: boolean = false
  visibleSourceMonth: boolean = false
  categoryStartMonth: any;
  categoryEndMonth: any;
  modelStartMonth: any;
  modelEndMonth: any;
  sourceStartMonth: any;
  sourceEndMonth: any;
  bsConfig!: Partial<BsDatepickerConfig>;

  onclick() {
    this.visibleCategoryMonth = !this.visibleCategoryMonth
  }
  onclick2() {
    this.visibleModelMonth = !this.visibleModelMonth
  }
  onclick3() {
    this.visibleSourceMonth = !this.visibleSourceMonth
  }
  preventTyping(event: KeyboardEvent): void {
    event.preventDefault();
  }

  clearCategory(): void {
    this.visibleCategoryMonth = false;
    let request = {
      startDate: this.startDate,
      endDate: this.endDate
    };

    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dpCategoryStart) {
      this.dpCategoryStart.bsValue = undefined;
    }
    if (this.dpCategoryEnd) {
      this.dpCategoryEnd.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.categoryStartMonth = undefined;
    this.categoryEndMonth = undefined;

    this.isGlobalDateCategory = true;
    this.getCategoryChartCounts();
  }

  clearModel(): void {
    this.visibleModelMonth = false;
    let request = {
      startDate: this.startDate,
      endDate: this.endDate
    };

    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dpModelStart) {
      this.dpModelStart.bsValue = undefined;
    }
    if (this.dpModelEnd) {
      this.dpModelEnd.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.modelStartMonth = undefined;
    this.modelEndMonth = undefined;
    this.isGlobalDateCategory = true;
    this.getModelChartCounts();
  }

  clearSource(): void {
    this.visibleSourceMonth = false;
    let request = {
      startDate: this.startDate,
      endDate: this.endDate
    };

    // Reset bsValue of dp1 and dp2 to undefined
    if (this.dpSourceStart) {
      this.dpSourceStart.bsValue = undefined;
    }
    if (this.dpSourceEnd) {
      this.dpSourceEnd.bsValue = undefined;
    }

    // Clear any selected start and end dates
    this.sourceStartMonth = undefined;
    this.sourceEndMonth = undefined;
    this.isGlobalDateCategory = true;
    // this.getSourceChartCounts();
    this.getSubSourceChartCounts();
  }

  clearFilter(data: any) {
    this.selectThisMonth();
    sessionStorage.removeItem('filterObject');
    this.isOneOutlet = false;
    this.modelSelectedAvg = null;
    this.categorySelectedAvg = null;
    this.sourceSelectedAvg = null;
    this.geographySelectedAvg = null;
    this.selectedRegionalMgrs = [];
    this.selectedZonalMgrs = [];
    this.selectedAreaMgrs = [];

    this.dropdownData.forEach((zone: any) => {
      zone.checked = false;
      zone.selectAllChecked = false;
      zone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.selectAllAreasChecked = false;
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // })
        });
      });
    })
    this.selectAllZoneChecked = false;
    this.selectAllModelChecked = false;
    this.selectAllCategoryChecked = false;

    this.userData.forEach((outlet: any) => {
      outlet.checked = false;
      outlet.Users.forEach((user: any) => {
        user.checked = false;
      })
    })
    this.filteredDataUsers = [...this.userData];
    this.searchTerm = '';
    this.userSearchTerm = '';
    this.categoryData.forEach((cat: any) => {
      cat.checked = false;
    })

    this.modelsData.forEach((model: any) => {
      model.checked = false;
    })
    this.filteredModelData = [...this.modelsData];

    this.sourceList.forEach((source: any) => {
      source.checked = false;
      source.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });
    });
    this.dealerData.forEach((dealer: any) => {
      dealer.checked = false;
      // dealer.Outlets.forEach((outlet: any) => {
      //   outlet.checked = false;
      // });
    })
    this.filteredDealerData = [...this.dealerData];
    this.filteredData = [...this.dropdownData];
    this.filteredDataSource = [...this.sourceList];
    // this.isLoading = new BehaviorSubject<boolean>(true);

    setTimeout(() => {
      // if (this.roleId != 8 && this.roleId != 9) {
      this.getGeographyChartCounts();
      this.getPerformanceCounts();
      // } else {
      //   this.getParentDealerChartCounts();
      //   this.getPerformanceCountsByPD();
      // }
      this.getCategoryChartCounts();
      this.getModelChartCounts();
      // this.getSourceChartCounts();
      this.getSubSourceChartCounts();
    }, 200)
    setTimeout(() => {
      // this.isLoading = new BehaviorSubject<boolean>(false);
      // if (this.roleId == 8 || this.roleId == 9) {
      //   this.getParentDealerTableData();
      // } else {
      this.getGeographyTableData();
      // }
      this.getModelTableData();
      this.getCategoryTableData();
      this.getSourceTableData();
    }, 2000)
    if (data) {
      this.getStageWiseCounts();
      this.getZoneWiseCounts();
    }
  }


  callApiOnCheck() {
    // this.isLoading = new BehaviorSubject<boolean>(true);
    // if (this.roleId != 8 && this.roleId != 9) {
    this.getPerformanceCounts();
    this.getGeographyChartCounts();
    // } else {
    //   this.getPerformanceCountsByPD();
    //   this.getParentDealerChartCounts();
    // }
    this.getCategoryChartCounts();
    this.getModelChartCounts();
    // this.getSourceChartCounts();
    this.getSubSourceChartCounts();
    setTimeout(() => {
      // if (this.roleId == 8 || this.roleId == 9) {
      //   this.getParentDealerTableData();
      // } else {
      this.getGeographyTableData();
      // }
      this.getModelTableData();
      this.getCategoryTableData();
      this.getSourceTableData();
      // this.isLoading = new BehaviorSubject<boolean>(false);
    }, 1600)
  }

  autoCheck(zone: any, region: any) {
    /** Autocheck logic */
    let anyRegionChecked: boolean = false;
    let anyAreaChecked: boolean = false;

    let initialCheck: boolean = false;
    initialCheck = zone.Regions.some((region: any) => region.checked);
    let initialCheckArea: boolean = false;
    if (region) {
      initialCheckArea = region.Areas.some((area: any) => area.checked);
    }
    if (!initialCheck) {
      for (const zoneItem of this.dropdownData) {
        let loopZoneId: any = zoneItem.zone_id
        // Check if any region in the current zone is checked
        anyRegionChecked = zoneItem.Regions.some((region: any) => region.checked && zone.zone_id != loopZoneId);

        if (anyRegionChecked) {
          zone.Regions.forEach((region: any) => {
            region.checked = true;
            // Check if any area is checked anywhere in dropdownData (not just current region)
            anyAreaChecked = this.dropdownData.some((z: any) =>
              z.Regions.some((r: any) => r.Areas.some((area: any) => area.checked))
            );

            if (anyAreaChecked) {
              region.Areas.forEach((area: any) => {
                area.checked = true;
              });
            }
          });
        }
      }
    }

    if (initialCheck && !initialCheckArea) {
      for (const zoneItem of this.dropdownData) {
        let loopZoneId: any = zoneItem.zone_id
        // Check if any region in the current zone is checked
        anyRegionChecked = zoneItem.Regions.some((region: any) => region.checked && zone.zone_id != loopZoneId);

        if (anyRegionChecked) {
          zone.Regions.forEach((reg: any) => {
            // Check if any area is checked anywhere in dropdownData (not just current region)
            anyAreaChecked = this.dropdownData.some((z: any) =>
              z.Regions.some((r: any) => r.Areas.some((area: any) => area.checked))
            );

            if (anyAreaChecked) {
              region.Areas.forEach((area: any) => {
                area.checked = true;
              });
            }
          });
        }
      }
    }
  }

  autoCheckDealer(dealer: any) {
    /** Autocheck logic */
    let anyOutletChecked: boolean = false;
    let initialCheck: boolean = false;
    initialCheck = dealer.Outlets.some((outlet: any) => outlet.checked);
    if (!initialCheck) {
      for (const dealerItem of this.dealerData) {
        let loopDealerId: any = dealerItem.parent_dealer_id
        anyOutletChecked = dealerItem.Outlets.some((outlet: any) => outlet.checked && dealer.parent_dealer_id != loopDealerId);
        if (anyOutletChecked) {
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = true;
          });
        }
      }
    }
  }

  onDealerCheck(event: any, dealerId: any) {
    let dealer = this.dealerData.find((z: any) => z.parent_dealer_id == dealerId);
    let filteredDealer = this.filteredDealerData.find((z: any) => z.parent_dealer_id == dealerId);

    if (event.checked) {
      filteredDealer.checked = true;
      dealer.checked = true;
      this.autoCheckDealer(dealer);
    } else {
      filteredDealer.checked = false;
      dealer.checked = false;

      dealer.Outlets.forEach((outlet: any) => {
        outlet.checked = false;
      });

      filteredDealer.Outlets.forEach((outlet: any) => {
        outlet.checked = false;
      });
    }
  }

  onOutletCheck(event: any, dealerId: any, outletId: any) {

    let dealer = this.dealerData.find((z: any) => z.parent_dealer_id == dealerId);

    let outlet = this.dealerData.find((r: any) => r.outlet_id == outletId);
    // Find the zone and region in filteredData using id
    let filteredDealer = this.filteredDealerData.find((z: any) => z.parent_dealer_id == dealerId);
    let filteredOutlet = this.filteredDealerData.find((r: any) => r.outlet_id == outletId);
    if (event.checked) {
      outlet.checked = true
      filteredOutlet.checked = true
      // const anyOutletChecked = dealer.Outlets.some((r: any) => r.checked);
      // if (anyOutletChecked) {
      //   dealer.checked = true;
      // }

      // const anyOutletCheckedInFiltered = filteredDealer.Outlets.some((r: any) => r.checked);
      // if (anyOutletCheckedInFiltered) {
      //   filteredDealer.checked = true;
      // }
    } else {
      outlet.checked = false;
      filteredOutlet.checked = false;
    }
  }

  isAnyAreaChecked: boolean = false;
  updateSelectAllStatus() {
    this.dropdownData.forEach((zone: any) => {
      // Update `selectAupdateSelectAllStatus() {
      this.dropdownData.forEach((zone: any) => {
        zone.States.forEach((state: any) => {
          const allStateChecked = zone.States.every((state: any) => state.checked);
          zone.selectALlStateChecked = allStateChecked
          // Update `selectAllAreasChecked` for each region
          state.Regions.forEach((region: any) => {
            const allAreasChecked = region.ParentDealers.every((dealer: any) => dealer.checked);
            region.selectAllAreasChecked = allAreasChecked;
          });

          // Update `selectAllChecked` for the zone
          const allRegionsChecked = state.Regions.every((region: any) => region.checked);
          state.selectAllChecked = allRegionsChecked;
        });
      });
      this.filterDealerByArea();
      let checkedAreas: any = []
      checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)        // Flatten regions
        .flatMap((region: any) => region.ParentDealers)      // Flatten areas
        .filter((area: any) => area.checked)         // Filter checked areas
        .map((area: any) => area.parent_dealer_id);
      if (checkedAreas.length > 0) {
        this.isAnyAreaChecked = true
      } else {
        this.isAnyAreaChecked = false
      }
    })
  }

  selectAllZoneChecked: boolean = false;
  onZoneCheckAll(event: any) {
    if (event.checked) {
      this.selectAllZoneChecked = true;
      this.dropdownData.forEach((zone: any) => {
        zone.checked = true;
      });
    } else {
      this.selectAllZoneChecked = false;
      this.dropdownData.forEach((zone: any) => {
        zone.checked = false;
        zone.States.forEach((state: any) => {
          state.checked = false;
          state.Regions.forEach((region: any) => {
            region.checked = false;
            // region.Areas.forEach((area: any) => {
            //   area.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
            })
            // });
          })
        })
      });
    }
    this.updateSelectAllStatus();
  }

  onZoneCheck(event: any, zoneId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    if (event.checked) {
      filteredZone.checked = true;
      zone.checked = true;
      // this.autoCheck(zone, null);
    } else {
      filteredZone.checked = false;
      zone.checked = false;

      zone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // });
        });
      });

      filteredZone.States.forEach((state: any) => {
        state.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
          })
          // });
        });
      });
    }
    this.updateSelectAllStatus()
  }

  onRegionCheckAll(event: any, zoneId: any, stateId: any, stateObj: any) {
    let zone: any = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((z: any) => z.state_id == stateId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((z: any) => z.state_id == stateId);
    if (event.checked) {
      // this.autoCheck(zone, null)
      zone.checked = true;
      filteredZone.checked = true;
      state.checked = true;
      filteredState.checked = true;
      stateObj.Regions.forEach((region: any) => {
        let regionToCheck = state.Regions.find((r: any) => r.region_id === region.region_id);
        let filteredRegionToCheck = filteredState.Regions.find((r: any) => r.region_id === region.region_id);

        if (regionToCheck) regionToCheck.checked = true;
        if (filteredRegionToCheck) filteredRegionToCheck.checked = true;
      });
    } else {

      stateObj.Regions.forEach((region: any) => {
        let regionToUncheck = state.Regions.find((r: any) => r.region_id === region.region_id);
        let filteredRegionToUncheck = filteredState.Regions.find((r: any) => r.region_id === region.region_id);

        if (regionToUncheck) regionToUncheck.checked = false;
        if (filteredRegionToUncheck) filteredRegionToUncheck.checked = false;

        // region.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });
    }
    this.updateSelectAllStatus()
  }

  updateSelectAllRegion(zoneId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    // Check if every region is checked
    let allRegionsChecked = zone.Regions.every((region: any) => region.checked);

    // Update the "Select All" checkbox for this zone
    zone.selectAllChecked = allRegionsChecked;
    filteredZone.selectAllChecked = allRegionsChecked;
  }
  onRegionCheck(event: any, zoneId: any, stateId: any, regionId: any) {
    // Find the zone and region in dropdownData using id
    let zone = { ...this.dropdownData.find((z: any) => z.zone_id == zoneId) };
    let state = zone?.States.find((r: any) => r.state_id == stateId);
    let region = state?.Regions.find((r: any) => r.region_id == regionId);

    // Find the zone and region in filteredData using id
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone?.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState?.Regions.find((r: any) => r.region_id == regionId);

    if (event.checked) {
      // this.autoCheck(zone, region);
      state.checked = true;
      filteredState.checked = true;
      region.checked = true
      filteredRegion.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anyRegionChecked = zone.States.some((r: any) => r.checked);
      if (anyRegionChecked) {
        zone.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anyRegionCheckedInFiltered = filteredZone.States.some((r: any) => r.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      region.checked = false;
      // region?.Areas.forEach((area: any) => {
      //   area.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
        // })
      });

      filteredRegion.checked = false;
      // filteredRegion?.Areas.forEach((area: any) => {
      //   area.checked = false;
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
          // });
        })
      });
    }
    this.updateSelectAllStatus()
  }


  onAreaCheckAll(event: any, zoneId: any, stateId: any, regionId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((r: any) => r.state_id == stateId);
    let region = state.Regions.find((r: any) => r.region_id == regionId);

    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState.Regions.find((r: any) => r.region_id == regionId);

    if (event.checked) {
      zone.checked = true;
      filteredZone.checked = true;

      state.checked = true;
      filteredState.checked = true;

      region.checked = true;
      filteredRegion.checked = true;
      // Check all areas within this region
      // region.Areas.forEach((area: any) => {
      //   area.checked = true;

      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = true;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = true;
        });
      })

      // });

      // filteredRegion.Areas.forEach((area: any) => {
      //   area.checked = true;

      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.checked = true;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = true;
        });
      })
      // });
    } else {
      // Uncheck all areas within this region
      // region.Areas.forEach((area: any) => {
      //   area.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
      })
      // });

      // filteredRegion.Areas.forEach((area: any) => {
      //   area.checked = false;
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.checked = false;
        dealer.Outlets.forEach((outlet: any) => {
          outlet.checked = false;
        });
      })
      // });
    }
    this.updateSelectAllStatus()
  }

  updateRegionSelectAllStatus(zoneId: any, regionId: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let region = zone.Regions.find((r: any) => r.region_id == regionId);
    let allAreasChecked = region.Areas.every((area: any) => area.checked);

    // Update the "Select All" checkbox for areas
    region.selectAllAreasChecked = allAreasChecked;
  }

  onAreaCheck(event: any, zoneId: any, stateId: any, regionId: any, outletId: any) {

    // Find the zone, region, and area based on the provided ids
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let state = zone.States.find((r: any) => r.state_id == stateId);
    let region = state.Regions.find((r: any) => r.region_id == regionId);
    // let area = region.Areas.find((a: any) => a.area_id == areaId);

    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone.States.find((r: any) => r.state_id == stateId);
    let filteredRegion = filteredState.Regions.find((r: any) => r.region_id == regionId);
    // let filteredArea = filteredRegion.Areas.find((a: any) => a.area_id == areaId);

    if (event.checked) {
      region.checked = true;
      filteredRegion.checked = true;
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            dealer.checked = true;       // Check the dealer if the outlet matches
            outlet.checked = true;       // Check only the specific outlet
          }
        });
      })
      region.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            dealer.checked = true;       // Check the dealer if the outlet matches
            outlet.checked = true;       // Check only the specific outlet
          }
        });
      });

      const areaChecked = region.checked;
      // Set region checked if any area is checked
      if (areaChecked) {
        state.checked = areaChecked
        region.checked = areaChecked;
      }

      // Set zone checked if any region is checked
      const anyRegionChecked = state.Regions.some((region: any) => region.checked);
      if (anyRegionChecked) {
        zone.checked = anyRegionChecked;
      }

      // Repeat the same process for the filtered data
      const areaCheckedInFiltered = region.checked;

      // Set region checked if any area is checked in filtered data
      if (areaCheckedInFiltered) {
        filteredState.checked = areaCheckedInFiltered;
        filteredRegion.checked = areaCheckedInFiltered;
      }

      // Set zone checked if any region is checked in filtered data
      const anyRegionCheckedInFiltered = filteredZone.States.some((region: any) => region.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = areaCheckedInFiltered;
      }
    } else {
      // filteredRegion.checked = false;
      // region.checked = false;
      region.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            outlet.checked = false;       // Check only the specific outlet
          }
        });
        const allOutletsUnchecked = dealer.Outlets.every((outlet: any) => !outlet.checked);

        // If all outlets are unchecked, uncheck the dealer
        if (allOutletsUnchecked) {
          dealer.checked = false;
          // filteredRegion.checked = false;
          // region.checked = false;
        }
      })
      filteredRegion.ParentDealers.forEach((dealer: any) => {
        dealer.Outlets.forEach((outlet: any) => {
          if (outlet.outlet_id === outletId) {
            outlet.checked = false;       // Check only the specific outlet
          }
        });
        const allOutletsUnchecked = dealer.Outlets.every((outlet: any) => !outlet.checked);

        // If all outlets are unchecked, uncheck the dealer
        if (allOutletsUnchecked) {
          dealer.checked = false;
          // filteredRegion.checked = false;
          // region.checked = false;
        }
      })
    }
    this.updateSelectAllStatus()
  }

  onBaseSourceCheck(event: any, baseSourceId: any) {
    let baseSource = this.sourceList.find((z: any) => z.id == baseSourceId);
    let filteredBaseSource = this.filteredDataSource.find((z: any) => z.id == baseSourceId);

    if (event.checked) {
      filteredBaseSource.checked = true;
      baseSource.checked = true;

    } else {
      filteredBaseSource.checked = false;
      baseSource.checked = false;

      baseSource.lead_sources.forEach((source: any) => {
        source.checked = false;
        source.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      });

      filteredBaseSource.lead_sources.forEach((source: any) => {
        source.checked = false;
        source.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      });
    }
    this.updateSelectAllSource()
  }

  onSourceCheck(event: any, baseSourceId: any, sourceId: any) {
    let source = this.sourceList.find((r: any) => r.id == sourceId);

    let filteredSource = this.filteredDataSource.find((r: any) => r.id == sourceId);

    if (event.checked) {
      source.checked = true
      filteredSource.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anySourceChecked = source.lead_sub_sources.some((r: any) => r.checked);
      if (anySourceChecked) {
        source.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anySourceCheckedInFiltered = filteredSource.lead_sub_sources.some((r: any) => r.checked);
      if (anySourceCheckedInFiltered) {
        filteredSource.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      source.checked = false;
      source?.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });

      filteredSource.checked = false;
      filteredSource?.lead_sub_sources.forEach((ss: any) => {
        ss.checked = false;
      });
    }
    this.updateSelectAllSource();
  }

  updateSelectAllSource() {
    this.sourceList.forEach((leadsource: any) => {
      const allSubsourceChecked = leadsource.lead_sub_sources.every((area: any) => area.checked);
      leadsource.selectAllSubSourceChecked = allSubsourceChecked;
    });

    // Update `selectAllChecked` for the zone
    this.selectAllSourceChecked = this.filteredDataSource.every((source: any) => source.checked);
    // source.selectAllSourceChecked = allLeadSourceChecked;
    // });
  }

  selectAllSourceChecked: boolean = false;
  onSourceCheckAll(event: any) {
    if (event.checked) {
      this.sourceList.forEach((item: any) => {
        item.checked = true;
      })
      this.selectAllSourceChecked = true;
    } else {
      this.sourceList.forEach((item: any) => {
        item.checked = false;
        item.lead_sub_sources.forEach((subsource: any) => {
          subsource.checked = false;
        });
      })
      this.selectAllSourceChecked = false;
    }

    this.updateSelectAllSource()
  }

  onSubSourceCheckAll(event: any, baseId: any, sourceId: any) {
    // let base = this.sourceList.find((z: any) => z.id == baseId);
    let leadsource = this.sourceList.find((r: any) => r.id == sourceId);

    // let filteredBase = this.filteredDataSource.find((z: any) => z.id == baseId);
    let filteredLeadSource = this.sourceList.find((r: any) => r.id == sourceId);

    if (event.checked) {
      // base.checked = true;
      // filteredBase.checked = true;

      leadsource.checked = true;
      filteredLeadSource.checked = true;
      // Check all areas within this region
      leadsource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = true;
      });

      filteredLeadSource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = true;
      });
    } else {
      // Uncheck all areas within this region
      leadsource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = false;
      });

      filteredLeadSource.lead_sub_sources.forEach((subsource: any) => {
        subsource.checked = false;
      });
    }
    this.updateSelectAllSource()
  }

  onSubsourceCheck(event: any, baseSourceId: any, sourceId: any, subSourceId: any) {
    // Find the zone, region, and area based on the provided ids
    // let baseSource = this.sourceList.find((z: any) => z.id == baseSourceId);
    let source = this.sourceList.find((r: any) => r.id == sourceId);
    let subSource = source.lead_sub_sources.find((a: any) => a.id == subSourceId);

    // let filteredBaseSource = this.filteredDataSource.find((z: any) => z.id == baseSourceId);
    let filteredSource = this.sourceList.find((r: any) => r.id == sourceId);
    let filteredSubSource = filteredSource.lead_sub_sources.find((a: any) => a.id == subSourceId);

    if (event.checked) {
      subSource.checked = true;
      filteredSubSource.checked = true;

      const subSourceChecked = subSource.checked;
      // Set region checked if any area is checked
      if (subSourceChecked) {
        source.checked = subSourceChecked;
      }

      // Set zone checked if any region is checked
      // const anySourceChecked = baseSource.lead_sources.some((ls: any) => ls.checked);
      // if (anySourceChecked) {
      //   baseSource.checked = anySourceChecked;
      // }

      // Repeat the same process for the filtered data
      const subSourceCheckedInFiltered = filteredSubSource.checked;

      // Set region checked if any area is checked in filtered data
      if (subSourceCheckedInFiltered) {
        filteredSource.checked = subSourceCheckedInFiltered;
      }

      // Set zone checked if any region is checked in filtered data
      // const anySourceCheckedInFiltered = filteredBaseSource.lead_sources.some((ls: any) => ls.checked);
      // if (anySourceCheckedInFiltered) {
      //   filteredBaseSource.checked = subSourceCheckedInFiltered;
      // }
    } else {
      filteredSubSource.checked = false;
      subSource.checked = false;
    }
    this.updateSelectAllSource();
  }

  onCategoryCheck(event: any, catId: any) {
    const checkedCategoryIds = this.categoryData
      .filter((category: any) => category.checked)  // Filter categories where checked is true
      .map((category: any) => category.category_id);         // Map only the category IDs
    const allUnchecked = this.categoryData.every((category: any) => !category.checked);
    this.modelsData.forEach((model: any) => {
      if (!checkedCategoryIds.includes(model.category_id)) {
        model.checked = false;
      }
    })
    if (allUnchecked) {
      this.filteredModelData = [...this.modelsData]; // Reset filtered model data if all categories are unchecked
    } else {
      this.filteredModelData = [...this.modelsData.filter((model: any) => checkedCategoryIds.includes(model.category_id))]
    }
  }

  onModelCheck(event: any) {

  }

  onUserCheck(event: any) {

  }


  // onOutletCheck(event: any, outletId: any) {
  //   let outlet = this.userData.find((z: any) => z.outlet_id == outletId);
  //   let filteredOutlet = this.filteredDataUsers.find((z: any) => z.outlet_id == outletId);

  //   if (event.checked) {
  //     filteredOutlet.checked = true;
  //     outlet.checked = true;

  //   } else {
  //     filteredOutlet.checked = false;
  //     outlet.checked = false;

  //     outlet.Users.forEach((user: any) => {
  //       user.checked = false;
  //     });

  //     filteredOutlet.Users.forEach((user: any) => {
  //       user.checked = false;
  //     });
  //   }
  // }

  onSalesUserCheck(event: any, outletId: any, userId: any) {
    let outlet: any = this.userData.find((z: any) => z.outlet_id == outletId);
    let user: any = outlet?.Users.find((r: any) => r.id == userId);

    let filteredOutlet = this.filteredDataUsers.find((z: any) => z.outlet_id == outletId);
    let filteredUsers = filteredOutlet?.Users.find((r: any) => r.id == userId);
    if (event.checked) {
      user.checked = true
      filteredUsers.checked = true
      const anyUserChecked = outlet.Users.some((r: any) => r.checked);
      if (anyUserChecked) {
        outlet.checked = true;
      }

      const anyUserCheckedInFiltered = filteredOutlet.Users.some((r: any) => r.checked);
      if (anyUserCheckedInFiltered) {
        filteredOutlet.checked = true;
      }
    } else {
      user.checked = false;
      filteredUsers.checked = false;
    }
  }

  applyFilter() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs


    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)     // Filter checked regions
      .map((state: any) => state.state_id);            // Map to region IDs

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);                // Map to area IDs

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        // .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);


      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);

    }

    if (checkedOutlet.length == 1) {
      this.isOneOutlet = true;
    } else {
      this.isOneOutlet = false;
      this.modelSelectedAvg = null;
      this.categorySelectedAvg = null;
      this.sourceSelectedAvg = null;
      this.geographySelectedAvg = null;
    }
    filterObject.startDate = moment(this.startDate).format('YYYY-MM-DD');
    filterObject.endDate = moment(this.endDate).format('YYYY-MM-DD');
    filterObject.selectedButton = this.selectedButton;
    filterObject.zones = checkedZones;
    filterObject.states = checkedStates;
    filterObject.regions = checkedRegions;
    filterObject.areas = checkedAreas;
    filterObject.categories = checkedCategories;
    filterObject.models = checkedModels;
    filterObject.baseLeadSource = checkedBaseLeadSource;
    filterObject.source = checkedSource;
    filterObject.subSource = checkedSubSource;
    filterObject.users = checkedUsers;
    filterObject.parentDealer = checkedDealer;
    filterObject.outlet = checkedOutlet;
    filterObject.isOneOutlet = this.isOneOutlet;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
    this.callApiOnCheck();
  }
  isShowOutletsOnly: boolean = false;

  searchTerm: string = ''; // Bind this to the search input
  filteredData: any = [...this.dropdownData]; // Initialize filtered data
  // Filter logic to filter zones, regions, and areas based on the search term
  filterDropdownData() {
    const searchLower = this.searchTerm.toLowerCase();

    this.filteredData = this.dropdownData.map((zone: any) => ({
      ...zone,
      States: zone.States.map((state: any) => ({
        ...state,
        Regions: state.Regions.map((region: any) => ({
          ...region,
          ParentDealers: region.ParentDealers.map((dealer: any) => ({
            ...dealer,
            Outlets: dealer.Outlets.filter((outlet: any) =>
              outlet.outlet_name.toLowerCase().includes(searchLower)
            )
          })).filter((dealer: any) =>
            dealer.parent_dealer_name.toLowerCase().includes(searchLower) ||
            dealer.Outlets.length > 0
          )
        })).filter((region: any) =>
          region.region_name.toLowerCase().includes(searchLower) ||
          region.ParentDealers.length > 0
        )
      })).filter((state: any) =>
        state.state_name.toLowerCase().includes(searchLower) ||
        state.Regions.length > 0
      )
    })).filter((zone: any) =>
      zone.zone_name.toLowerCase().includes(searchLower) ||
      zone.States.length > 0
    );
  }


  searchTermDealer: string = ''; // Bind this to the search input
  filterDealerData() {
    const searchLower = this.searchTermDealer.toLowerCase();
    this.filteredDealerData = this.dealerData.map((dealer: any) => ({
      ...dealer,
      Outlets: dealer.Outlets.map((outlet: any) => ({
        ...outlet
      })).filter((outlet: any) => outlet.outlet_name.toLowerCase().includes(searchLower))
    })).filter((dealer: any) => dealer.parent_dealer_name.toLowerCase().includes(searchLower) || dealer.Outlets.length > 0);
  }


  userSearchTerm: string = ''; // Bind this to the search input
  filterUserData() {
    const searchLower = this.userSearchTerm.toLowerCase();

    // Only filter based on the outlet name
    this.filteredDataUsers = this.userData.filter((outlet: any) =>
      outlet.outlet_name.toLowerCase().includes(searchLower)
    );
  }

  geographySelectedField: any = "Retailed"
  geographySlider(item: any, slider: any) {
    if (slider.checked) {
      this.geographySelectedField = item.name
      this.geographyToggle.forEach((element: any) => {
        if (element.name != item.name) {
          element.checked = false;
        }
      });
      setTimeout(() => {
        // if (this.roleId == 8 || this.roleId == 9) {
        //   this.getParentDealerTableData();
        // } else {
        this.getGeographyTableData();
        // }
      }, 200);
    } else {
      setTimeout(() => {
        item.checked = true; // Reset the item's checked value to true
      }, 0);
    }

  }



  categorySelectedField: any = "Retailed"
  categorySlider(item: any, slider: any) {
    if (slider.checked) {
      this.categorySelectedField = item.name
      this.categoryToggle.forEach((element: any) => {
        if (element.name != item.name) {
          element.checked = false;
        }
      });
      setTimeout(() => {
        this.getCategoryTableData()
      }, 200);
    } else {
      setTimeout(() => {
        item.checked = true; // Reset the item's checked value to true
      }, 0);
    }

  }

  modelSelectedField: any = "Retailed"
  modelSlider(item: any, slider: any) {
    if (slider.checked) {
      this.modelSelectedField = item.name
      this.modelToggle.forEach((element: any) => {
        if (element.name != item.name) {
          element.checked = false;
        }
      });
      setTimeout(() => {
        this.getModelTableData()
      }, 200);
    } else {
      setTimeout(() => {
        item.checked = true; // Reset the item's checked value to true
      }, 0);
    }

  }

  sourceSelectedField: any = "Retailed"
  sourceSlider(item: any, slider: any) {
    if (slider.checked) {
      this.sourceSelectedField = item.name
      this.sourceToggle.forEach((element: any) => {
        if (element.name != item.name) {
          element.checked = false;
        }
      });
      setTimeout(() => {
        this.getSourceTableData();
      }, 200);
    } else {
      setTimeout(() => {
        item.checked = true; // Reset the item's checked value to true
      }, 0);
    }

  }



  /** Service call & Data Manipulations */
  getGeographyList() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    let request: any = {};
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getGeography(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          this.dropdownData = responseData.data
          if (!this.isEmpty(filterObject)) {
            if (filterObject.zones) {
              this.dropdownData.forEach((zone: any) => {
                if (filterObject.zones.includes(zone.zone_id)) {
                  zone.checked = true;
                  zone.States.forEach((state: any) => {
                    if (filterObject.states.includes(state.state_id)) {
                      state.checked = true;
                      state.Regions.forEach((region: any) => {
                        if (filterObject.regions.includes(region.region_id)) {
                          region.checked = true;
                          // region.Areas.forEach((area: any) => {
                          //   if (filterObject.areas.includes(area.area_id)) {
                          //     area.checked = true;
                          region.ParentDealers.forEach((dealer: any) => {
                            if (filterObject.parentDealer.includes(dealer.parent_dealer_id)) {
                              dealer.checked = true;
                            }
                            dealer.Outlets.forEach((outlet: any) => {
                              if (filterObject.outlet.includes(outlet.outlet_id)) {
                                outlet.checked = true;
                              }
                            });
                          });
                          //   }
                          // });
                        }
                      });
                    }
                  });
                }
              });
            }
            setTimeout(() => {
              //   if(this.roleId == 8 || this.roleId == 9 ){
              //   this.dealerData = this.dropdownData.flatMap((zone: any) =>
              //     zone.States.flatMap((state: any) =>
              //       state.Regions.flatMap((region: any) =>
              //         region.Areas
              //           .filter((area: any) =>
              //             (filterObject?.areas || []).includes(area.area_id)
              //           )
              //           .flatMap((filteredArea: any) =>
              //             filteredArea.ParentDealers.map((dealer: any) => ({
              //               ...dealer,
              //               checked: (filterObject?.parentDealer || []).includes(dealer.parent_dealer_id),
              //               Outlets: dealer.Outlets.map((outlet: any) => ({
              //                 ...outlet,
              //                 checked: (filterObject?.outlet || []).includes(outlet.outlet_id)
              //               }))
              //             }))
              //           )
              //       )
              //     )
              //   );
              // }    
              let everyZoneChecked: boolean = false;
              everyZoneChecked = this.dropdownData.every((zone: any) => zone.checked)
              this.selectAllZoneChecked = everyZoneChecked;
              this.updateSelectAllStatus();
            }, 300)
          } else {
            this.filterDealerByArea();
          }
          this.getZoneWiseCounts();
          this.filteredData = [...this.dropdownData]; // Initialize filtered data

        }
      },
      error: (err) => {
      },
      complete: () => {
        setTimeout(() => {
          this.getStageWiseCounts();
        }, 1000)
        setTimeout(() => {
          this.getGeographyChartCounts();
          this.getCategoryChartCounts();
          this.getModelChartCounts();
          this.getSubSourceChartCounts();

        }, 2500)

        setTimeout(() => {
          this.getGeographyTableData();
          this.getCategoryTableData();
          this.getModelTableData();
          this.getSourceTableData();
        }, 3500)
      }
    });
  }

  stageCounts: any = { totalLead: 0, booked: 0, retailed: 0, testRide: 0, retailedPer: 0, bookedPer: 0, testRidePer: 0 };
  getStageWiseCounts() {
    this.startLoading();
    let filterObject: any = {}
    let selectedZonalMgrs: any = []
    let selectedRegionalMgrs: any = []
    let selectedAreaMgrs: any = []
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.zonalManagers) {
        selectedZonalMgrs = filterObject.zonalManagers || [];
        selectedRegionalMgrs = filterObject.regionalManagers || [];
        selectedAreaMgrs = filterObject.areaManagers || [];
      }
    }

    let checkedZones: any = [];
    let checkedRegions: any = []
    let checkedAreas: any = []
    let checkedDealer: any = [];
    let checkedOutlet: any = [];
    let checkedStates: any = []

    if (selectedZonalMgrs.length > 0 || selectedRegionalMgrs.length > 0 || selectedAreaMgrs.length > 0) {
      checkedZones = this.dropdownData
        .filter((zone: any) => zone.checked)         // Filter checked zones
        .map((zone: any) => zone.zone_id);

      if (selectedRegionalMgrs.length > 0) {
        checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
          .flatMap((zone: any) => zone.Regions)        // Flatten regions
          .filter((region: any) => region.checked)     // Filter checked regions
          .map((region: any) => region.region_id);

        checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
          .filter((state: any) => state.checked)
          .map((state: any) => state.state_id);
      }

      if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
        checkedDealer = [
          ...new Set(
            this.dealerData
              .filter((dealer: any) => dealer.checked)
              .map((dealer: any) => dealer.parent_dealer_id)
          )
        ];

        checkedOutlet = this.dealerData
          .filter((outlet: any) => outlet.checked)
          .map((outlet: any) => outlet.outlet_id);

      } else {
        if (selectedAreaMgrs.length > 0) {
          checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
            .flatMap((zone: any) => zone.Regions)
            // .flatMap((region: any) => region.Areas)
            .flatMap((area: any) => area.ParentDealers)
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id);

          checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
            .flatMap((zone: any) => zone.Regions)
            // .flatMap((region: any) => region.Areas)
            .flatMap((area: any) => area.ParentDealers)
            .flatMap((dealer: any) => dealer.Outlets)
            .filter((outlet: any) => outlet.checked)
            .map((outlet: any) => outlet.outlet_id);
        }
      }
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.stage_id": this.stageIds
    }
    if (this.selectedZone?.id) {
      request['outlet_details.zone_id'] = [this.selectedZone?.id]
    } else if (checkedZones.length > 0 && this.selectedZonalMgrs.length > 0) {
      request['outlet_details.zone_id'] = checkedZones
    }
    if (checkedRegions.length > 0 && this.selectedRegionalMgrs.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0 && this.selectedAreaMgrs.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }
    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getStageCounts(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          // this.isLoading = new BehaviorSubject<boolean>(false);
          if (responseData?.data) {
            let responseObj: any = responseData?.data
            this.stageCounts.totalLead = responseObj?.totalLead ? responseObj?.totalLead : 0;
            this.stageCounts.booked = responseObj?.bookedOrderCount ? responseObj?.bookedOrderCount : 0;
            this.stageCounts.retailed = responseObj?.retailedInvoicedCount ? responseObj?.retailedInvoicedCount : 0;
            this.stageCounts.testRide = responseObj?.sumTestRideCount ? responseObj?.sumTestRideCount : 0;

            // Percentage
            this.stageCounts.bookedPer = responseObj?.percentageBookedOrder ? responseObj?.percentageBookedOrder : 0;
            this.stageCounts.retailedPer = responseObj?.percentageRetailedInvoiced ? responseObj?.percentageRetailedInvoiced : 0;
            this.stageCounts.testRidePer = responseObj?.percentageTestRideCount ? responseObj?.percentageTestRideCount : 0;
          } else {
            this.stageCounts = { totalLead: 0, booked: 0, retailed: 0, testRide: 0, retailedPer: 0, bookedPer: 0, testRidePer: 0 }
          }
        } else {
          // this.isLoading = new BehaviorSubject<boolean>(false);
          this.stageCounts = { totalLead: 0, booked: 0, retailed: 0, testRide: 0, retailedPer: 0, bookedPer: 0, testRidePer: 0 }
        }
      },
      error: (err) => {
        console.error('Error fetching zone counts:', err);
        this.stopLoading(); // Ensure loader stops on error
      },
      complete: () => {
        this.stopLoading(); // Ensure loader stops after completion
      }
    });
  }

  getSourceList() {
    this.productivityService.getLeadSource({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.sourceList = responseData.data
        if (!this.isEmpty(this.filterObject)) {
          if (this.filterObject.baseLeadSource) {
            this.sourceList.forEach((baseSource: any) => {
              if (this.filterObject.baseLeadSource.includes(baseSource.id)) {
                baseSource.checked = true;
                baseSource.lead_sources.forEach((source: any) => {
                  if (this.filterObject.source.includes(source.id)) {
                    source.checked = true;
                    source.lead_sub_sources.forEach((subSource: any) => {
                      if (this.filterObject.subSource.includes(subSource.id)) {
                        subSource.checked = true;
                      }
                    });
                  }
                });
              }
            });
          }
          setTimeout(() => {
            this.updateSelectAllSource();
          }, 300)
        }
        this.sourceList = this.flattenLeadSources(this.sourceList);
        //   let obj :any = {
        //     "id": 4,
        //     "lead_source": "DMS",
        //     "status": true,
        //     "lead_sub_sources": [],
        //     "base_lead_source_id": 1,
        //     "selectAllSubSourceChecked": true
        // }
        //  this.sourceList.push(obj);
        //       console.log("sourceList: ", this.sourceList)
        this.filteredDataSource = [...this.sourceList]; // Initialize filtered data
      }
    });
  }

  flattenLeadSources(data: any) {
    let leadSourcesArray: any = [];

    data.forEach((baseSource: any) => {
      baseSource.lead_sources.forEach((leadSource: any) => {
        leadSourcesArray.push({
          ...leadSource,
          base_lead_source_id: baseSource.id // Assign base lead source ID
        });
      });
    });

    return leadSourcesArray;
  }

  filteredDataUsers: any = []
  getUserList() {
    let request: any = {}
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getUser(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        let data: any = responseData.data
        if (data.length > 0) {
          this.userData = data;
          if (!this.isEmpty(this.filterObject)) {
            if (this.filterObject.users) {
              this.userData.forEach((outlet: any) => {
                outlet.Users.forEach((user: any) => {
                  if (this.filterObject.users.includes(user.id)) {
                    user.checked = true;
                  }
                });
              });
            }
          }
          this.filteredDataUsers = [...this.userData]
        }
      }
    });
  }

  filteredModelData: any = [];
  getProductList() {
    this.productivityService.getProduct({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        if (responseData.data.length > 0) {
          this.categoryData = responseData.data
          if (!this.isEmpty(this.filterObject)) {
            if (this.filterObject.categories) {
              this.categoryData.forEach((category: any) => {
                if (this.filterObject.categories.includes(category.category_id)) {
                  category.checked = true;
                  category.Models.forEach((model: any) => {
                    if (this.filterObject.models) {
                      if (this.filterObject.models.includes(model.model_id)) {
                        model.checked = true;
                      }
                    }
                  })
                }
              });
            }
          }
          this.modelsData = [...this.categoryData.reduce((acc: any, category: any) => {
            return acc.concat(category.Models);
          }, [])];
          this.filteredModelData = [...this.modelsData]

        }
      }
    });
  }

  filteredDealerData: any = [];
  dealerData: any = [];
  getDealerOutletList() {
    let req: any = { "is_outlet_all": this.isActiveOutlet ? 2 : 1 };
    this.productivityService.getDealersAndOutlets(req).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        if (responseData.data.length > 0) {
          this.dealerData = [...responseData.data];
          if (!this.isEmpty(this.filterObject)) {
            if (this.filterObject.parentDealer) {
              this.dealerData.forEach((dealer: any) => {
                if (this.filterObject.parentDealer.includes(dealer.parent_dealer_id)) {
                  dealer.checked = true;
                  dealer.Outlets.forEach((outlet: any) => {
                    if (this.filterObject.outlet.includes(outlet.outlet_id)) {
                      outlet.checked = true;
                    }
                  });
                }
              });
            }
          }
          this.dealerData = this.flattenParentDealer(this.dealerData)
          this.filteredDealerData = [...this.dealerData]
        }
      }
    });
  }

  flattenParentDealer(data: any) {
    let outletsArray: any = [];

    data.forEach((dealer: any) => {
      dealer.Outlets.forEach((outlet: any) => {
        outletsArray.push({
          ...outlet,
          parent_dealer_id: dealer.parent_dealer_id // Assign base lead source ID
        });
      });
    });
    return outletsArray;
  }

  allZoneCounts: any = []
  getZoneWiseCounts() {
    this.startLoading();
    let filterObject: any = {}
    let selectedZonalMgrs: any = []
    let selectedRegionalMgrs: any = []
    let selectedAreaMgrs: any = []
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.zonalManagers) {
        selectedZonalMgrs = filterObject.zonalManagers || [];
        selectedRegionalMgrs = filterObject.regionalManagers || [];
        selectedAreaMgrs = filterObject.areaManagers || [];
      }
    }

    let checkedZones: any = [];
    let checkedRegions: any = []
    let checkedAreas: any = []
    let checkedDealer: any = [];
    let checkedOutlet: any = [];
    let checkedStates: any = []

    if (selectedZonalMgrs.length > 0 || selectedRegionalMgrs.length > 0 || selectedAreaMgrs.length > 0) {
      checkedZones = this.dropdownData
        .filter((zone: any) => zone.checked)         // Filter checked zones
        .map((zone: any) => zone.zone_id);

      if (selectedRegionalMgrs.length > 0) {
        checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
          .flatMap((zone: any) => zone.Regions)        // Flatten regions
          .filter((region: any) => region.checked)     // Filter checked regions
          .map((region: any) => region.region_id);

        checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
          .filter((state: any) => state.checked)
          .map((state: any) => state.state_id);
      }

      if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
        checkedDealer = [
          ...new Set(
            this.dealerData
              .filter((dealer: any) => dealer.checked)
              .map((dealer: any) => dealer.parent_dealer_id)
          )
        ];

        checkedOutlet = this.dealerData
          .filter((outlet: any) => outlet.checked)
          .map((outlet: any) => outlet.outlet_id);

      } else {
        if (selectedAreaMgrs.length > 0) {
          checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
            .flatMap((zone: any) => zone.Regions)
            // .flatMap((region: any) => region.Areas)
            .flatMap((area: any) => area.ParentDealers)
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id);

          checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
            .flatMap((zone: any) => zone.Regions)
            // .flatMap((region: any) => region.Areas)
            .flatMap((area: any) => area.ParentDealers)
            .flatMap((dealer: any) => dealer.Outlets)
            .filter((outlet: any) => outlet.checked)
            .map((outlet: any) => outlet.outlet_id);
        }
      }
    }
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "outlet_details.zone_id",
      "colFlag": 2, //static mandatory
      "responseType": "arrayOfObjects",
      "current_stage.stage_id": this.stageIds
    }
    if (checkedZones.length > 0) {
      request['outlet_details.zone_id'] = checkedZones
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }
    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.headerCards = [];
    this.productivityService.getZoneCounts(request).subscribe({
      next: (response: any) => {
        let responseData: any = response.body;
        if (responseData.responseCode == 200) {
          if (responseData.data && responseData.data.currentCount) {
            // Get the counts from currentCount and calculate total
            this.totalLeadsInZones = Object.values(responseData.data.currentCount).reduce((sum, item: any) => sum + (item.count || 0), 0);
            this.totalLeads = this.totalLeadsInZones
          }
          this.dropdownData.forEach((item: any) => {
            // Flag to track if zone_id is found
            let found = false;
            responseData?.data?.currentCount.forEach((element: any) => {
              if (item.zone_id == element.id) {
                // If a match is found, push the object and set the flag to true
                this.headerCards.push({ id: item.zone_id, name: item.zone_name.replace(/\s\(\d+\)$/, ''), value: element.count });
                found = true;
              }
            });
            // If no match was found, push the default value only if the object is not already in headerCards
            if (!found && !this.headerCards.some((card: any) => card.id == item.zone_id)) {
              this.headerCards.push({ id: item.zone_id, name: item.zone_name.replace(/\s\(\d+\)$/, ''), value: 0 });
            }
          });
          /**To sort the zones by id */
          this.headerCards.sort((a: any, b: any) => a.id - b.id);
          this.headerCards = this.headerCards.map((card: any) => {
            const percentage = this.calculatePercentage(card.value);
            return {
              ...card,
              percentage  // Add the percentage as a property to each card
            };
          });

          const customOrder = ["East", "North", "South 1", "South 2", "West"];

          const sorted = this.headerCards.sort((a: any, b: any) => {
            return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
          });
        }
      },
      error: (err) => {
        console.error('Error fetching zone counts:', err);
        this.stopLoading(); // Ensure loader stops on error
      },
      complete: () => {
        this.stopLoading(); // Ensure loader stops after completion
      }
    });
  }

  performanceData: any = [];
  getPerformanceCounts() {
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }
    if (checkedOutlet.length > 0) {
      this.isShowOutletsOnly = true;
    } else {
      this.isShowOutletsOnly = false;
    }
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "sel_priority_id": 10, //fixed
      "custrequirment_priority_id": 2,  //fixed
      "current_stage.stage_id": this.stageIds
    }
    let groupBy: any = []
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
      groupBy.push("zone")
    } else {
      if (this.roleId == 6) {
        groupBy.push('zone', 'state', "region")
      } else if (this.roleId == 7) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 8) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 5 || this.roleId == 10) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      }
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
      groupBy.push("state")
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
      groupBy.push("region")
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
      groupBy.push("area")
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
      if (!groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer");
      }
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      if (!groupBy.includes("outlet")) {
        groupBy.push("outlet");
      }
    }
    request["groupby"] = groupBy;
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getPerformanceCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.performanceData = responseData.data.sort((a: any, b: any) => b.totalCount - a.totalCount);
      } else {

      }
    });
  }

  getPerformanceCountsByPD() {

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);


    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "sel_priority_id": 10, //fixed
      "custrequirment_priority_id": 2,  //fixed
      "groupby": [
        "parentDealer",
        "outlet"
      ],
      "current_stage.stage_id": this.stageIds
    }

    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    // request["groupby"] = groupBy;
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getPerformanceCountsByPD(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.performanceData = responseData.data
      } else {

      }
    });
  }

  getGeographyChartCounts() {
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);


    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.stage_id": this.stageIds
    }
    let groupBy: any = []
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
      groupBy.push("zone")
    } else {
      if (this.roleId == 6) {
        groupBy.push('zone', 'state', "region")
      } else if (this.roleId == 7) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 8) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 5 || this.roleId == 10) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      } else {
        groupBy.push("zone")
      }
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
      groupBy.push("state")
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
      groupBy.push("region")
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
      groupBy.push("area")
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
      if (!groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer");
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer")
      }
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      if (!groupBy.includes("outlet")) {
        groupBy.push("outlet");
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("outlet")) {
        groupBy.push("outlet")
      }
    }
    if (checkedUsers.length > 0) {
      const valuesToPush = ['zone', 'region', 'area', 'parentDealer', 'outlet', 'user'];

      valuesToPush.forEach(value => {
        if (!groupBy.includes(value)) {
          groupBy.push(value);
        }
      });
    }

    request["groupby"] = groupBy;
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getGeographyChartCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.chartsData = [];
        this.regionData = [];
        if (responseData.data.currentData.length > 0) {
          this.regionData = responseData.data.currentData.sort((a: any, b: any) => b.count - a.count);
          setTimeout(() => {
            if (checkedUsers.length > 0) {
              this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((zone: any) => zone.regions).flatMap((region: any) => region.parentDealers).flatMap((dealer: any) => dealer.outlets)
              this.onUserChart();
            } else {
              if (checkedDealer.length > 0 || checkedOutlet.length > 0) {
                this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                this.onPDChart();
              } else {
                if (groupBy.includes("outlet") || groupBy.includes("parentDealer")) {
                  this.regionData = this.regionData.flatMap((zone: any) => zone.states).flatMap((state: any) => state.regions).flatMap((region: any) => region.parentDealers)
                  this.onPDChart();
                } else {
                  this.onZone();
                }
              }
            }
          }, 100)
        }
      }
    });
  }

  isGeography: boolean = true;
  geographyTotalLeads: any = 0;
  geographyTotalCounts: any = 0;
  geographyStagePercentage: any = 0;
  getGeographyTableData() {
    this.loadingTable1 = true;
    let checkedToggle: any = this.geographyToggle.find((item: any) => item.checked == true);
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      // "groupby": ['zone', 'region', 'area'],
      "current_stage.stage_id": this.stageIds
    }

    if (checkedToggle.id == 2) {
      request["custrequirment_priority_id"] = checkedToggle.id;
    } else {
      request["sel_priority_id"] = "current_stage.stage_id||" + checkedToggle.id;
    }

    let groupBy: any = []
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
      groupBy.push("zone")
    } else {
      if (this.roleId == 6) {
        groupBy.push('zone', 'state', "region")
      } else if (this.roleId == 7) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 8) {
        groupBy.push('zone', 'state', "region", 'parentDealer', 'outlet')
      } else if (this.roleId == 5 || this.roleId == 10) {
        groupBy.push('zone', "state", "region", 'parentDealer', 'outlet')
      }
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
      groupBy.push("state")
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
      groupBy.push("region")
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
      groupBy.push("area")
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
      if (!groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer")
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("parentDealer")) {
        groupBy.push("parentDealer")
      }
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      if (!groupBy.includes("outlet")) {
        groupBy.push("outlet")
      }
    } else {
      if (groupBy.includes("area") && !groupBy.includes("outlet")) {
        groupBy.push("outlet")
      }
    }

    if (checkedUsers.length > 0) {
      const valuesToPush = ['zone', 'region', 'area', 'parentDealer', 'outlet', 'user'];

      valuesToPush.forEach(value => {
        if (!groupBy.includes(value)) {
          groupBy.push(value);
        }
      });
    }
    request["groupby"] = groupBy.length > 0 ? groupBy : ['zone'];
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    if (this.isOneOutlet) {
      switch (this.geographySelectedAvg) {
        case 'national':
          request["is_national"] = {
            "zone_id": [1, 4, 2, 5, 3]
          }
          break;
        case 'zonal':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "zone_id": this.dropdownData
                .filter((zone: any) => zone.checked)
                .map((zone: any) => zone.zone_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "zone_id": zoneData.zone_id
            }
          }
          break;
        case 'state':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "state_id": this.dropdownData.flatMap((zone: any) => zone.States)
                .filter((state: any) => state.checked)     // Filter checked regions
                .map((state: any) => state.state_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "state_id": zoneData.state_id
            }
          }

          break;
        default:
          break;
      }
    }
    this.productivityService.getGeographyChartCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.geographyStatus = [];
        if (responseData.data.currentData.length > 0) {
          responseData.data.currentData.forEach((zone: any) => {

            if (groupBy.length === 0 || groupBy.length === 1) {
              this.geographyStatus.push({
                name: zone.zone_name,
                leads: zone.count,
                count: zone.selectStageCount,
                percentage: zone.selectStageCount === 0 ? 0 : ((zone.selectStageCount / zone.count) * 100).toFixed(2)
              });
            }

            if (zone.states) {
              zone.states.forEach((state: any) => {
                if (groupBy.length === 2) {
                  this.geographyStatus.push({
                    name: state.state_name,
                    leads: state.count,
                    count: state.selectStageCount,
                    percentage: state.selectStageCount === 0 ? 0 : ((state.selectStageCount / state.count) * 100).toFixed(2)
                  });
                }

                if (state.regions) {
                  state.regions.forEach((region: any) => {
                    if (!groupBy.includes("outlet")) {
                      this.geographyStatus.push({
                        name: region.region_name,
                        leads: region.count,
                        count: region.selectStageCount,
                        percentage: region.selectStageCount === 0 ? 0 : ((region.selectStageCount / region.count) * 100).toFixed(2)
                      });
                    }

                    // if (region.areas) {
                    //   region.areas.forEach((area: any) => {
                    if (region.parentDealers) {
                      region.parentDealers.forEach((dealer: any) => {
                        if (dealer.outlets) {
                          dealer.outlets.forEach((outlet: any) => {
                            const enqAverage = responseData.data.total_count === 0
                              ? 0
                              : Math.round(responseData.data.total_count / responseData.data.outlet_count);
                            let stageAverage
                            if (checkedToggle.id == 2) {
                              stageAverage = (() => {
                                const p = responseData.data.unique_test_ride_count / responseData.data.outlet_count;
                                return responseData.data.unique_test_ride_count === 0 ? 0 : (p < 0.5 && p > 0 ? 1 : Math.round(p));
                              })();
                            } else {
                              stageAverage = (() => {
                                const p = responseData.data.stage_count / responseData.data.outlet_count;
                                return responseData.data.stage_count === 0 ? 0 : (p < 0.5 && p > 0 ? 1 : Math.round(p));
                              })();
                            }
                            this.geographyStatus.push({
                              name: outlet.outlet_name,
                              leads: outlet.count || 0,
                              count: outlet.selectStageCount || 0,
                              percentage: outlet.selectStageCount === 0
                                ? 0
                                : ((outlet.selectStageCount / outlet.count) * 100).toFixed(2),
                              enqAverage,
                              stageAverage,
                              stageAveragePer: enqAverage === 0
                                ? 0
                                : (() => {
                                  const value = (stageAverage / enqAverage) * 100;
                                  return value % 1 === 0 ? value : value.toFixed(2);
                                })()
                            });
                          });
                        }
                      });
                    }
                    //   });
                    // }
                  });
                }
              });
            }
          });
        }
        this.geographyStatus = this.geographyStatus.sort((a: any, b: any) => b.count - a.count);
        this.geographyTotalLeads = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.leads || 0), 0) || 0;
        this.geographyTotalCounts = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.count || 0), 0) || 0;
        this.geographyTotalLeadAvg = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.enqAverage || 0), 0) || 0;
        this.geographyTotalCountAvg = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.stageAverage || 0), 0) || 0;
        this.loadingTable1 = false;
        if (this.geographyTotalCounts === 0 || this.geographyTotalLeads === 0) {
          this.geographyStagePercentage = 0; // or handle it however you prefer
        } else {
          this.geographyStagePercentage = ((this.geographyTotalCounts / this.geographyTotalLeads) * 100).toFixed(2);
        }
        if (this.geographyTotalLeadAvg == 0 || this.geographyTotalCountAvg == 0) {
          this.geographyTotalCountAvgPer = 0
        } else {
          const geoAvgValue = (this.geographyTotalCountAvg / this.geographyTotalLeadAvg) * 100;
          this.geographyTotalCountAvgPer = geoAvgValue % 1 === 0 ? geoAvgValue : geoAvgValue.toFixed(2);
        }
      }
    });
  }

  compareCategory() {
    if (this.categoryStartMonth && this.categoryEndMonth) {
      this.isGlobalDateCategory = false;
      this.getCategoryChartCounts();
    } else {
      this.toastr.error("From and To month is required to compare")
    }
  }

  productCategoryResponse: any = {};
  @ViewChild('categoryChart') categoryChart!: ChartComponent;
  getCategoryChartCounts() {
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {};
    if (!this.isGlobalDateCategory) {
      const startDateA = moment(this.categoryStartMonth).startOf('month').format('YYYY-MM-DD');
      const endDateA = moment(this.categoryStartMonth).endOf('month').format('YYYY-MM-DD');

      const startDateB = moment(this.categoryEndMonth).startOf('month').format('YYYY-MM-DD');
      const endDateB = moment(this.categoryEndMonth).endOf('month').format('YYYY-MM-DD');

      request = {
        "startDate": startDateA, //mandatory
        "endDate": endDateA, //mandatory
        "groupby": "product_details.product_category_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "compareStartDate": startDateB,
        "compareEndDate": endDateB,
        "current_stage.stage_id": this.stageIds
      }
    } else {
      request = {
        "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
        "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
        "groupby": "product_details.product_category_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "current_stage.stage_id": this.stageIds
      }
    }

    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }
    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.productCategoryResponse = responseData.data.currentCount;
        this.productCategoryOptions.series = [];
        this.productCategoryOptions.xaxis.categories = [];
        if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
          if (this.isGlobalDateCategory) {
            this.productCategoryResponse.sort((a: any, b: any) => b.count - a.count);
            this.productCategoryOptions.series.push({ name: 'Enquiries', data: [] })
            this.productCategoryResponse.forEach((item: any) => {
              this.productCategoryOptions.series[0].data.push(item.count)
              this.productCategoryOptions.xaxis.categories.push([item.name ? item.name : 'Not Mapped'])
            })

            setTimeout(() => {
              this.categoryChart.updateOptions({
                xaxis: {
                  categories: this.productCategoryOptions.xaxis.categories,
                },
                legend: {
                  show: true   // Dynamically hide the legend
                }
              });
            }, 100);

          } else {
            if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
              let currentCount: any = responseData.data.currentCount.length > 0
                ? responseData.data.currentCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];

              let compareCount: any = responseData.data.compareCount.length > 0
                ? responseData.data.compareCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];
              // Handle if either array is empty
              const uniqueIds = new Set([
                ...((currentCount && currentCount.length > 0) ? currentCount.map((item: any) => item.id) : []),
                ...((compareCount && compareCount.length > 0) ? compareCount.map((item: any) => item.id) : [])
              ]);

              let updatedCurrentCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount.find((item: any) => item.id === id);
                const compareItem = compareCount.find((item: any) => item.id === id);

                // Only add to currentCount if it exists in currentCount or compareCount
                return currentItem || { count: 0, selectStageCount: 0, id, name: compareItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name (i.e., those not present in either array)

              let updatedCompareCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount?.find((item: any) => item.id === id);
                const compareItem = compareCount?.find((item: any) => item.id === id);

                // Only add to compareCount if it exists in currentCount or compareCount
                return compareItem || { count: 0, id, name: currentItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name

              updatedCurrentCount.sort((a: any, b: any) => a.id - b.id);
              updatedCompareCount.sort((a: any, b: any) => a.id - b.id);

              let dataSet1: any = updatedCurrentCount.map((item: any) => item.count)
              let catName: any = updatedCompareCount.map((item: any) => item.name || 'Not Mapped');
              let catArray: any = []
              let dataSet1Array: any = []
              let dataSet2Array: any = []
              const colorsDark = [
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",   // Original colors
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",   // First additional set
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366"               // New additional colors
              ];
              updatedCurrentCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet1Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorsDark[colorIndex] });
              });
              catName.forEach((item: any) => {
                catArray.push([item])
              })
              this.productCategoryOptions.xaxis.categories = catArray;
              this.productCategoryOptions.series.push({ name: moment(this.categoryStartMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet1Array })

              const colorslight = ["#B3CDFF", "#A6EFEF", "#FCE9B6", "#ECA8EC", "#C8CCF9", "#D4D4D4", "#FFC4A3", "#A9E5C0", "#FFE8A8", "#A6E2EB", "#CBB6E9", "#A8F0D9", "#F7A5C7", "#FEC6A0", "#F4A3A7", "#C4B0F9", "#809CCC"]

              updatedCompareCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet2Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorslight[colorIndex] });
              });
              let dataSet2: any = responseData.data.compareCount.map((item: any) => item.count)
              this.productCategoryOptions.series.push({ name: moment(this.categoryEndMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet2Array })
              setTimeout(() => {
                this.categoryChart.updateOptions({
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              }, 100)

            } else {
              //No data
              this.productCategoryOptions.series.push({ name: 'Enquiries', data: [] });
            }

          }
          setTimeout(() => {
            if (this.categoryChart) {
              this.categoryChart.updateOptions({
                xaxis: {
                  categories: this.productCategoryOptions.xaxis.categories,
                },
                series: this.productCategoryOptions.series,
              });
            }
          }, 400)
        }
      }
    });
  }

  categoryTotalLeads: any = 0;
  categoryTotalCounts: any = 0;
  categoryStagePercentage: any = 0;

  getCategoryTableData() {
    this.loadingTable2 = true;
    let checkedToggle: any = this.categoryToggle.find((item: any) => item.checked == true);
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);
    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "product_details.product_category_id", //static
      "colFlag": 2, //static
      "responseType": "arrayOfObjects", //static
      "current_stage.stage_id": this.stageIds
    }
    if (checkedToggle.id == 2) {
      request["custrequirment_priority_id"] = checkedToggle.id;
    } else {
      request["sel_priority_id"] = "current_stage.stage_id||" + checkedToggle.id;
    }
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    if (this.isOneOutlet) {
      switch (this.categorySelectedAvg) {
        case 'national':
          request["is_national"] = {
            "zone_id": [1, 4, 2, 5, 3]
          }
          break;
        case 'zonal':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "zone_id": this.dropdownData
                .filter((zone: any) => zone.checked)
                .map((zone: any) => zone.zone_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "zone_id": zoneData.zone_id
            }
          }
          break;
        case 'state':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "state_id": this.dropdownData.flatMap((zone: any) => zone.States)
                .filter((state: any) => state.checked)     // Filter checked regions
                .map((state: any) => state.state_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "state_id": zoneData.state_id
            }
          }

          break;
        default:
          break;
      }
    }
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.categoryStatus = [];
        responseData.data.currentCount.forEach((item: any) => {
          const enqAverage = (() => {
            const p = item.totalcount / responseData.data.outlet_count;
            return item.totalcount === 0 ? 0 : (p < 0.9 && p > 0 ? 1 : Math.round(p));
          })();

          const stageAverage = (() => {
            const p = item.totalStageCount / responseData.data.outlet_count;
            return item.totalStageCount === 0 ? 0 : (p < 0.5 && p > 0 ? 1 : Math.round(p));
          })();

          this.categoryStatus.push({
            id: item.id, name: item.name ? item.name : 'Not Mapped', count: item.selectStageCount, leads: item.count, percentage: item.selectStageCount === 0 ? 0 : ((item.selectStageCount / item.count) * 100).toFixed(2),
            enqAverage,
            stageAverage,
            stageAveragePer: enqAverage === 0
              ? 0
              : (() => {
                const value = (stageAverage / enqAverage) * 100;
                return value % 1 === 0 ? value : value.toFixed(2);
              })()
          })
        })
        this.categoryStatus.sort((a: any, b: any) => b.count - a.count);
        this.categoryTotalLeads = this.categoryStatus?.reduce((sum: any, zone: any) => sum + (zone.leads || 0), 0) || 0;
        this.categoryTotalCounts = this.categoryStatus?.reduce((sum: any, zone: any) => sum + (zone.count || 0), 0) || 0;
        this.categoryTotalLeadAvg = this.categoryStatus?.reduce((sum: any, zone: any) => sum + (zone.enqAverage || 0), 0) || 0;
        this.categoryTotalCountAvg = this.categoryStatus?.reduce((sum: any, zone: any) => sum + (zone.stageAverage || 0), 0) || 0;
        this.loadingTable2 = false;
        if (this.categoryTotalCounts === 0 || this.categoryTotalLeads === 0) {
          this.categoryStagePercentage = 0; // or handle it however you prefer
        } else {
          this.categoryStagePercentage = ((this.categoryTotalCounts / this.categoryTotalLeads) * 100).toFixed(2);
        }
        if (this.categoryTotalLeadAvg == 0 || this.categoryTotalCountAvg == 0) {
          this.categoryTotalCountAvgPer = 0
        } else {
          const geoAvgValue = (this.categoryTotalCountAvg / this.categoryTotalLeadAvg) * 100;
          this.categoryTotalCountAvgPer = geoAvgValue % 1 === 0 ? geoAvgValue : geoAvgValue.toFixed(2);
        }
      }
    });
  }

  compareModel() {
    if (this.modelStartMonth && this.modelEndMonth) {
      this.isGlobalDateCategory = false;
      this.getModelChartCounts();
    } else {
      this.toastr.error("From and To month is required to compare!")
    }
  }

  productModelResponse: any = {};
  @ViewChild('modelChart') modelChart!: ChartComponent;
  getModelChartCounts() {
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {};
    if (!this.isGlobalDateCategory) {
      const startDateA = moment(this.modelStartMonth).startOf('month').format('YYYY-MM-DD');
      const endDateA = moment(this.modelStartMonth).endOf('month').format('YYYY-MM-DD');

      const startDateB = moment(this.modelEndMonth).startOf('month').format('YYYY-MM-DD');
      const endDateB = moment(this.modelEndMonth).endOf('month').format('YYYY-MM-DD');

      request = {
        "startDate": startDateA, //mandatory
        "endDate": endDateA, //mandatory
        "groupby": "product_details.product_model_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "compareStartDate": startDateB,
        "compareEndDate": endDateB,
        "current_stage.stage_id": this.stageIds
      }
    } else {
      request = {
        "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
        "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
        "groupby": "product_details.product_model_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "current_stage.stage_id": this.stageIds
      }
    }

    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.productModelResponse = responseData.data.currentCount;
        this.productModelOptions.series = [];
        this.productModelOptions.xaxis.categories = [];
        if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
          if (this.isGlobalDateCategory) {

            if (responseData.data.currentCount.length > 0) {
              let response: any = responseData.data.currentCount
              response.sort((a: any, b: any) => b.count - a.count);
              let dataSet: any = response.map((item: any) => item.count)
              let catName: any = response.map((item: any) => item.name || 'Not Mapped');
              let catArray: any = [];
              catName.forEach((item: any) => {
                catArray.push([item])
              })
              this.productModelOptions.xaxis.categories = catArray;
              this.productModelOptions.series.push({ name: 'Enquiries', data: dataSet })
              setTimeout(() => {
                this.modelChart.updateOptions({
                  legend: {
                    show: true
                  }
                });
              }, 100)
            } else {
              this.productModelOptions.series.push({ name: 'Enquiries', data: [] })
            }
          } else {
            if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
              let currentCount: any = responseData.data.currentCount.length > 0
                ? responseData.data.currentCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];

              let compareCount: any = responseData.data.compareCount.length > 0
                ? responseData.data.compareCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Not Mapped',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];
              // Handle if either array is empty
              const uniqueIds = new Set([
                ...((currentCount && currentCount.length > 0) ? currentCount.map((item: any) => item.id) : []),
                ...((compareCount && compareCount.length > 0) ? compareCount.map((item: any) => item.id) : [])
              ]);

              let updatedCurrentCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount.find((item: any) => item.id === id);
                const compareItem = compareCount.find((item: any) => item.id === id);

                // Only add to currentCount if it exists in currentCount or compareCount
                return currentItem || { count: 0, selectStageCount: 0, id, name: compareItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name (i.e., those not present in either array)

              let updatedCompareCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount?.find((item: any) => item.id === id);
                const compareItem = compareCount?.find((item: any) => item.id === id);

                // Only add to compareCount if it exists in currentCount or compareCount
                return compareItem || { count: 0, id, name: currentItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name

              updatedCurrentCount.sort((a: any, b: any) => a.id - b.id);
              updatedCompareCount.sort((a: any, b: any) => a.id - b.id);

              // Resulting arrays
              // console.log(updatedCurrentCount);
              // console.log(updatedCompareCount);


              let dataSet1: any = updatedCurrentCount.map((item: any) => item.count)
              let catName: any = updatedCompareCount.map((item: any) => item.name || 'Not Mapped');
              let catArray: any = []
              let dataSet1Array: any = []
              let dataSet2Array: any = []
              const colorsDark = [
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",   // Original colors
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",   // First additional set
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366"               // New additional colors
              ];
              updatedCurrentCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet1Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorsDark[colorIndex] });
              });
              catName.forEach((item: any) => {
                catArray.push([item])
              })
              this.productModelOptions.xaxis.categories = catArray;
              this.productModelOptions.series.push({ name: moment(this.modelStartMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet1Array })

              const colorslight = ["#B3CDFF", "#A6EFEF", "#FCE9B6", "#ECA8EC", "#C8CCF9", "#D4D4D4", "#FFC4A3", "#A9E5C0", "#FFE8A8", "#A6E2EB", "#CBB6E9", "#A8F0D9", "#F7A5C7", "#FEC6A0", "#F4A3A7", "#C4B0F9", "#809CCC"]

              updatedCompareCount.forEach((item: any, index: number) => {
                // Use the modulus operator to cycle through colors
                const colorIndex = index % colorsDark.length;
                dataSet2Array.push({ x: item.name ? item.name : 'Not Mapped', y: item.count, fillColor: colorslight[colorIndex] });
              });
              let dataSet2: any = responseData.data.compareCount.map((item: any) => item.count)
              this.productModelOptions.series.push({ name: moment(this.modelEndMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet2Array })
              setTimeout(() => {
                this.modelChart.updateOptions({
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              }, 100)

            } else {
              //No data
              this.productModelOptions.series.push({ name: 'Enquiries', data: [] });
            }

          }
          setTimeout(() => {

            if (this.modelChart) {
              const totalBars = this.productModelOptions?.series[0]?.data?.length;
              // console.log("totalBars: ", totalBars)
              const barWidth = 190; // Fixed width for each bar
              let totalWidth: any
              if (totalBars > 3) {
                // Calculate the total width needed for all bars
                totalWidth = totalBars * barWidth;
                if (totalWidth < 990 && 700 < totalWidth) {
                  totalWidth = 1000;
                }
                if (totalWidth < 500) {
                  totalWidth = 750;
                }
              }
              this.modelChart.updateOptions({
                chart: {
                  width: totalBars > 3 ? totalWidth + 'px' : '100%'
                },
                xaxis: {
                  categories: this.productModelOptions.xaxis.categories,
                  range: 3,
                },
                series: this.productModelOptions.series,
              });
            }
          }, 500)
        }

      }
    });
  }

  modelTotalLeads: any = 0;
  modelTotalCounts: any = 0;
  modelStagePercentage: any = 0;

  getModelTableData() {
    this.loadingTable3 = true;
    let checkedToggle: any = this.modelToggle.find((item: any) => item.checked == true)
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "product_details.product_model_id", //static
      "colFlag": 2, //static
      "responseType": "arrayOfObjects", //static
      "current_stage.stage_id": this.stageIds
    }
    if (checkedToggle.id == 2) {
      request["custrequirment_priority_id"] = checkedToggle.id;
    } else {
      request["sel_priority_id"] = "current_stage.stage_id||" + checkedToggle.id;
    }
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    if (this.isOneOutlet) {
      switch (this.modelSelectedAvg) {
        case 'national':
          request["is_national"] = {
            "zone_id": [1, 4, 2, 5, 3]
          }
          break;
        case 'zonal':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "zone_id": this.dropdownData
                .filter((zone: any) => zone.checked)
                .map((zone: any) => zone.zone_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "zone_id": zoneData.zone_id
            }
          }
          break;
        case 'state':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "state_id": this.dropdownData.flatMap((zone: any) => zone.States)
                .filter((state: any) => state.checked)     // Filter checked regions
                .map((state: any) => state.state_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "state_id": zoneData.state_id
            }
          }

          break;
        default:
          break;
      }
    }
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.modelStatus = [];
        responseData.data.currentCount.forEach((item: any) => {
          const enqAverage = (() => {
            const p = item.totalcount / responseData.data.outlet_count;
            return item.totalcount === 0 ? 0 : (p < 0.9 && p > 0 ? 1 : Math.round(p));
          })();

          const stageAverage = (() => {
            const p = item.totalStageCount / responseData.data.outlet_count;
            return item.totalStageCount === 0 ? 0 : (p < 0.5 && p > 0 ? 1 : Math.round(p));
          })();

          this.modelStatus.push({
            id: item.id, name: item.name ? item.name : 'Not Mapped', count: item.selectStageCount, leads: item.count, percentage: item.selectStageCount === 0 ? 0 : ((item.selectStageCount / item.count) * 100).toFixed(2),
            enqAverage,
            stageAverage,
            stageAveragePer: enqAverage === 0
              ? 0
              : (() => {
                const value = (stageAverage / enqAverage) * 100;
                return value % 1 === 0 ? value : value.toFixed(2);
              })()
          })
        })
        this.modelStatus.sort((a: any, b: any) => b.count - a.count);
        this.modelTotalLeads = this.modelStatus?.reduce((sum: any, zone: any) => sum + (zone.leads || 0), 0) || 0;
        this.modelTotalCounts = this.modelStatus?.reduce((sum: any, zone: any) => sum + (zone.count || 0), 0) || 0;
        this.modelTotalLeadAvg = this.modelStatus?.reduce((sum: any, zone: any) => sum + (zone.enqAverage || 0), 0) || 0;
        this.modelTotalCountAvg = this.modelStatus?.reduce((sum: any, zone: any) => sum + (zone.stageAverage || 0), 0) || 0;
        this.loadingTable3 = false;
        if (this.modelTotalCounts === 0 || this.modelTotalLeads === 0) {
          this.modelStagePercentage = 0; // or handle it however you prefer
        } else {
          this.modelStagePercentage = Math.round((this.modelTotalCounts / this.modelTotalLeads) * 100);
        }
        if (this.modelTotalLeadAvg == 0 || this.modelTotalCountAvg == 0) {
          this.modelTotalCountAvgPer = 0
        } else {
          const geoAvgValue = (this.modelTotalCountAvg / this.modelTotalLeadAvg) * 100;
          this.modelTotalCountAvgPer = geoAvgValue % 1 === 0 ? geoAvgValue : geoAvgValue.toFixed(2);
        }
      }
    });
  }

  compareSourceAndSubSource() {
    if (this.sourceStartMonth && this.sourceEndMonth) {
      this.isGlobalDateCategory = false;
      // this.getSourceChartCounts();
      this.getSubSourceChartCounts();
    } else {
      this.toastr.error("From and To month is required to compare!")
    }
  }


  @ViewChild('sourceChart') sourceChart!: ChartComponent;
  sourceTableData: any = []
  getSourceChartCounts() {
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUser: any = []
    checkedUser = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {};
    if (!this.isGlobalDateCategory) {
      const startDateA = moment(this.sourceStartMonth).startOf('month').format('YYYY-MM-DD');
      const endDateA = moment(this.sourceStartMonth).endOf('month').format('YYYY-MM-DD');

      const startDateB = moment(this.sourceEndMonth).startOf('month').format('YYYY-MM-DD');
      const endDateB = moment(this.sourceEndMonth).endOf('month').format('YYYY-MM-DD');

      request = {
        "startDate": startDateA, //mandatory
        "endDate": endDateA, //mandatory
        "groupby": "base_lead_source_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "compareStartDate": startDateB,
        "compareEndDate": endDateB,
        "current_stage.stage_id": this.stageIds
      }
    } else {
      request = {
        "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
        "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
        "groupby": "base_lead_source_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "current_stage.stage_id": this.stageIds
      }
    }

    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUser.length > 0) {
      request["current_stage.assign_to"] = checkedUser;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.sourceOptions.series = [];
        this.sourceOptions.xaxis.categories = [];
        if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
          if (this.isGlobalDateCategory) {

            if (responseData.data.currentCount.length > 0) {
              let response: any = responseData.data.currentCount
              response.sort((a: any, b: any) => b.count - a.count);
              let dataSet: any = response.map((item: any) => item.count)
              let catName: any = response.map((item: any) => item.name || 'Unknown');
              this.sourceOptions.xaxis.categories = catName;
              this.sourceOptions.series.push({ name: 'Enquiries', data: dataSet })
              setTimeout(() => {
                this.sourceChart.updateOptions({
                  legend: {
                    show: true   // Dynamically hide the legend
                  }
                });
              }, 100)

            } else {
              //No data
              this.sourceOptions.series.push({ name: 'Enquiries', data: [] });
            }
          } else {
            if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
              let currentCount: any = responseData.data.currentCount.length > 0 ? responseData.data.currentCount : [];
              let compareCount: any = responseData.data.compareCount.length > 0 ? responseData.data.compareCount : [];
              // Handle if either array is empty
              const uniqueIds = new Set([
                ...((currentCount && currentCount.length > 0) ? currentCount.map((item: any) => item.id) : []),
                ...((compareCount && compareCount.length > 0) ? compareCount.map((item: any) => item.id) : [])
              ]);

              let updatedCurrentCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount.find((item: any) => item.id === id);
                const compareItem = compareCount.find((item: any) => item.id === id);

                // Only add to currentCount if it exists in currentCount or compareCount
                return currentItem || { count: 0, selectStageCount: 0, id, name: compareItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name (i.e., those not present in either array)

              let updatedCompareCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount?.find((item: any) => item.id === id);
                const compareItem = compareCount?.find((item: any) => item.id === id);

                // Only add to compareCount if it exists in currentCount or compareCount
                return compareItem || { count: 0, id, name: currentItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name

              updatedCurrentCount.sort((a: any, b: any) => a.id - b.id);
              updatedCompareCount.sort((a: any, b: any) => a.id - b.id);

              // Resulting arrays
              // console.log(updatedCurrentCount);
              // console.log(updatedCompareCount);


              let dataSet1: any = updatedCurrentCount.map((item: any) => item.count)
              let catName: any = updatedCurrentCount.map((item: any) => item.name || 'Unknown');
              this.sourceOptions.xaxis.categories = catName;
              this.sourceOptions.series.push({ name: moment(this.sourceStartMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet1 })

              let dataSet2: any = updatedCompareCount.map((item: any) => item.count)
              this.sourceOptions.series.push({ name: moment(this.sourceEndMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet2 })
              setTimeout(() => {
                this.sourceChart.updateOptions({
                  legend: {
                    show: false   // Dynamically hide the legend
                  }
                });
              }, 100)
            } else {
              //No data
              this.sourceOptions.series.push({ name: 'Enquiries', data: [] });
            }
          }
          if (this.sourceChart) {
            const totalBars = this.sourceOptions.series[0].data.length;
            const barWidth = 120; // Fixed width for each bar

            // Calculate the total width needed for all bars
            let totalWidth = totalBars * barWidth;
            if (totalWidth < 130) {
              totalWidth = 200
            }
            setTimeout(() => {
              this.sourceChart.updateOptions({
                chart: {
                  width: totalWidth + 'px'
                },
                xaxis: {
                  categories: this.sourceOptions.xaxis.categories
                },
                series: this.sourceOptions.series
              });
            }, 200);
          }
        }

      }
    });
  }

  sourceTotalLeads: any = 0;
  sourceTotalCounts: any = 0;
  sourceStagePercentage: any = 0;

  getSourceTableData() {
    this.loadingTable4 = true;
    let checkedToggle: any = this.sourceToggle.find((item: any) => item.checked == true)
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUser: any = []
    checkedUser = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "groupby": "lead_source_id", //static
      "colFlag": 2, //static
      "responseType": "arrayOfObjects", //static
      "current_stage.stage_id": this.stageIds
    }
    if (checkedToggle.id == 2) {
      request["custrequirment_priority_id"] = checkedToggle.id;
    } else {
      request["sel_priority_id"] = "current_stage.stage_id||" + checkedToggle.id;
    }
    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUser.length > 0) {
      request["current_stage.assign_to"] = checkedUser;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    if (this.isOneOutlet) {
      switch (this.sourceSelectedAvg) {
        case 'national':
          request["is_national"] = {
            "zone_id": [1, 4, 2, 5, 3]
          }
          break;
        case 'zonal':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "zone_id": this.dropdownData
                .filter((zone: any) => zone.checked)
                .map((zone: any) => zone.zone_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "zone_id": zoneData.zone_id
            }
          }
          break;
        case 'state':
          if (this.roleId != 5 && this.roleId != 10 && this.roleId != 8) {
            request["is_national"] = {
              "state_id": this.dropdownData.flatMap((zone: any) => zone.States)
                .filter((state: any) => state.checked)     // Filter checked regions
                .map((state: any) => state.state_id)
            }
          } else {
            let zoneData: any = {}
            zoneData = this.findZoneAndStateByOutletId(this.dropdownData, checkedOutlet[0])
            request["is_national"] = {
              "state_id": zoneData.state_id
            }
          }

          break;
        default:
          break;
      }
    }
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.sourceStatus = [];
        if (responseData.data.currentCount.length > 0) {
          responseData.data.currentCount.forEach((item: any) => {
            const enqAverage = (() => {
              const p = item.totalcount / responseData.data.outlet_count;
              return item.totalcount === 0 ? 0 : (p < 0.9 && p > 0 ? 1 : Math.round(p));
            })();

            const stageAverage = (() => {
              const p = item.totalStageCount / responseData.data.outlet_count;
              return item.totalStageCount === 0 ? 0 : (p < 0.5 && p > 0 ? 1 : Math.round(p));
            })();

            this.sourceStatus.push({
              id: item.id, name: item.name || 'Calls', leads: item.count, count: item.selectStageCount, percentage: item.selectStageCount === 0 ? 0 : ((item.selectStageCount / item.count) * 100).toFixed(2),
              enqAverage,
              stageAverage,
              stageAveragePer: enqAverage === 0
                ? 0
                : (() => {
                  const value = (stageAverage / enqAverage) * 100;
                  return value % 1 === 0 ? value : value.toFixed(2);
                })()
            })
          })
          this.sourceStatus.sort((a: any, b: any) => b.count - a.count);
        }
        this.sourceTotalLeads = this.sourceStatus.reduce((sum: any, item: any) => sum + (item.leads || 0), 0) || 0;
        this.sourceTotalCounts = this.sourceStatus.reduce((sum: any, item: any) => sum + (item.count || 0), 0) || 0;
        this.sourceTotalLeadAvg = this.sourceStatus?.reduce((sum: any, zone: any) => sum + (zone.enqAverage || 0), 0) || 0;
        this.sourceTotalCountAvg = this.sourceStatus?.reduce((sum: any, zone: any) => sum + (zone.stageAverage || 0), 0) || 0;
        this.loadingTable4 = false;
        if (this.sourceTotalCounts === 0 || this.sourceTotalLeads === 0) {
          this.sourceStagePercentage = 0; // or handle it however you prefer
        } else {
          this.sourceStagePercentage = ((this.sourceTotalCounts / this.sourceTotalLeads) * 100).toFixed(2);
        }
        if (this.sourceTotalLeadAvg == 0 || this.sourceTotalCountAvg == 0) {
          this.sourceTotalCountAvgPer = 0
        } else {
          const geoAvgValue = (this.sourceTotalCountAvg / this.sourceTotalLeadAvg) * 100;
          this.sourceTotalCountAvgPer = geoAvgValue % 1 === 0 ? geoAvgValue : geoAvgValue.toFixed(2);
        }
      }
    })
  }

  @ViewChild('subSourceChart') subSourceChart!: ChartComponent;
  subSourceTableData: any = []
  getSubSourceChartCounts() {
    // Get checked zone IDs
    let checkedZones: any = [];
    checkedZones = this.dropdownData
      .filter((zone: any) => zone.checked)         // Filter checked zones
      .map((zone: any) => zone.zone_id);                // Map to zone IDs

    let checkedStates: any = []
    checkedStates = this.dropdownData.flatMap((zone: any) => zone.States)
      .filter((state: any) => state.checked)
      .map((state: any) => state.state_id);

    // Get checked region IDs
    let checkedRegions: any = []
    checkedRegions = this.dropdownData.flatMap((zone: any) => zone.States)
      .flatMap((zone: any) => zone.Regions)        // Flatten regions
      .filter((region: any) => region.checked)     // Filter checked regions
      .map((region: any) => region.region_id);            // Map to region IDs

    // Get checked area IDs
    let checkedAreas: any = []
    // checkedAreas = this.dropdownData.flatMap((zone: any) => zone.States)
    //   .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //   .flatMap((region: any) => region.Areas)      // Flatten areas
    //   .filter((area: any) => area.checked)         // Filter checked areas
    //   .map((area: any) => area.area_id);        

    let checkedCategories: any = []
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUser: any = []
    checkedUser = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let checkedDealer: any = [];
    let checkedOutlet: any = []
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10) {
      checkedDealer = [
        ...new Set(
          this.dealerData
            .filter((dealer: any) => dealer.checked)
            .map((dealer: any) => dealer.parent_dealer_id)
        )
      ];

      checkedOutlet = this.dealerData
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    } else {
      checkedDealer = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .filter((dealer: any) => dealer.checked)
        .map((dealer: any) => dealer.parent_dealer_id);

      checkedOutlet = this.dropdownData.flatMap((zone: any) => zone.States)
        .flatMap((zone: any) => zone.Regions)
        // .flatMap((region: any) => region.Areas)
        .flatMap((area: any) => area.ParentDealers)
        .flatMap((dealer: any) => dealer.Outlets)
        .filter((outlet: any) => outlet.checked)
        .map((outlet: any) => outlet.outlet_id);
    }

    let request: any = {};
    if (!this.isGlobalDateCategory) {
      const startDateA = moment(this.sourceStartMonth).startOf('month').format('YYYY-MM-DD');
      const endDateA = moment(this.sourceStartMonth).endOf('month').format('YYYY-MM-DD');

      const startDateB = moment(this.sourceEndMonth).startOf('month').format('YYYY-MM-DD');
      const endDateB = moment(this.sourceEndMonth).endOf('month').format('YYYY-MM-DD');

      request = {
        "startDate": startDateA, //mandatory
        "endDate": endDateA, //mandatory
        "groupby": "lead_source_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "compareStartDate": startDateB,
        "compareEndDate": endDateB,
        "current_stage.stage_id": this.stageIds
      }
    } else {
      request = {
        "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
        "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
        "groupby": "lead_source_id", //static
        "colFlag": 2, //static
        "responseType": "arrayOfObjects", //static
        "current_stage.stage_id": this.stageIds
      }
    }

    if (checkedZones.length > 0) {
      request["outlet_details.zone_id"] = checkedZones;
    }
    if (checkedStates.length > 0) {
      request["outlet_details.state_id"] = checkedStates;
    }
    if (checkedRegions.length > 0) {
      request["outlet_details.region_id"] = checkedRegions;
    }
    if (checkedAreas.length > 0) {
      request["outlet_details.area_id"] = checkedAreas;
    }
    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUser.length > 0) {
      request["current_stage.assign_to"] = checkedUser;
    }
    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getZoneCounts(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.subSourceOptions.series = [];
        this.subSourceOptions.xaxis.categories = [];
        if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
          if (this.isGlobalDateCategory) {

            if (responseData.data.currentCount.length > 0) {
              let response: any = responseData.data.currentCount
              response.sort((a: any, b: any) => b.count - a.count);
              let dataSet: any = response.map((item: any) => item.count)
              let catName: any = response.map((item: any) => item.name || 'Calls');
              this.subSourceOptions.xaxis.categories = catName;
              this.subSourceOptions.series.push({ name: 'Enquiries', data: dataSet })
              setTimeout(() => {
                if (this.subSourceChart) {
                  this.subSourceChart.updateOptions({
                    legend: {
                      show: true   // Dynamically hide the legend
                    }
                  });
                }
              }, 100)
            } else {
              //No data
              this.subSourceOptions.series.push({ name: 'Enquiries', data: [] });
            }
          } else {
            if (responseData.data.currentCount.length > 0 || responseData.data.compareCount.length > 0) {
              let currentCount: any = responseData.data.currentCount.length > 0
                ? responseData.data.currentCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Calls',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];

              let compareCount: any = responseData.data.compareCount.length > 0
                ? responseData.data.compareCount.map((item: any) => ({
                  ...item,
                  name: item.name && item.name.trim() !== '' ? item.name : 'Calls',
                  id: item.name && item.name.trim() !== '' ? item.id : null
                }))
                : [];
              // Handle if either array is empty
              const uniqueIds = new Set([
                ...((currentCount && currentCount.length > 0) ? currentCount.map((item: any) => item.id) : []),
                ...((compareCount && compareCount.length > 0) ? compareCount.map((item: any) => item.id) : [])
              ]);

              let updatedCurrentCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount.find((item: any) => item.id === id);
                const compareItem = compareCount.find((item: any) => item.id === id);

                // Only add to currentCount if it exists in currentCount or compareCount
                return currentItem || { count: 0, selectStageCount: 0, id, name: compareItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name (i.e., those not present in either array)

              let updatedCompareCount: any = [...uniqueIds].map(id => {
                const currentItem = currentCount?.find((item: any) => item.id === id);
                const compareItem = compareCount?.find((item: any) => item.id === id);

                // Only add to compareCount if it exists in currentCount or compareCount
                return compareItem || { count: 0, id, name: currentItem?.name || '' };
              }).filter(item => item.name !== '');  // Filter out items with empty name

              updatedCurrentCount.sort((a: any, b: any) => a.id - b.id);
              updatedCompareCount.sort((a: any, b: any) => a.id - b.id);

              let dataSet1: any = updatedCurrentCount.map((item: any) => item.count)
              let catName: any = updatedCurrentCount.map((item: any) => item.name || 'Calls');
              this.subSourceOptions.xaxis.categories = catName;
              this.subSourceOptions.series.push({ name: moment(this.sourceStartMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet1 })

              let dataSet2: any = updatedCompareCount.map((item: any) => item.count)
              this.subSourceOptions.series.push({ name: moment(this.sourceEndMonth, 'MMMM').endOf('month').format('MMM-YY'), data: dataSet2 })
              setTimeout(() => {
                if (this.subSourceChart) {
                  this.subSourceChart.updateOptions({
                    legend: {
                      show: false   // Dynamically hide the legend
                    }
                  });
                }
              }, 200)
            } else {
              //No data
              this.subSourceOptions.series.push({ name: 'Enquiries', data: [] });
            }
          }
          setTimeout(() => {
            if (this.subSourceChart) {
              const totalBars = this.subSourceOptions.series[0].data.length;
              const barWidth = 180; // Fixed width for each bar

              // Calculate the total width needed for all bars
              const totalWidth = totalBars * barWidth;
              this.subSourceChart.updateOptions({
                chart: {
                  width: totalBars > 3 ? totalWidth + 'px' : '100%'
                },
                xaxis: {
                  categories: this.subSourceOptions.xaxis.categories
                },
                series: this.subSourceOptions.series
              });
            }
          }, 200)
        }

      }
    });
  }

  getParentDealerChartCounts() {
    let checkedDealer: any = [];
    checkedDealer = this.dealerData
      .filter((dealer: any) => dealer.checked)         // Filter checked zones
      .map((dealer: any) => dealer.parent_dealer_id);                // Map to zone IDs

    // Get checked region IDs
    let checkedOutlet: any = []
    checkedOutlet = this.dealerData
      .flatMap((dealer: any) => dealer.Outlets)        // Flatten regions
      .filter((outlet: any) => outlet.checked)     // Filter checked regions
      .map((outlet: any) => outlet.outlet_id);

    let checkedCategories: any = [];
    checkedCategories = this.categoryData.filter((category: any) => category.checked)         // Filter checked areas
      .map((category: any) => category.category_id);

    let checkedModels: any = []
    checkedModels = this.modelsData.filter((model: any) => model.checked)     // Filter checked regions
      .map((model: any) => model.model_id);

    let checkedBaseLeadSource: any = []
    checkedBaseLeadSource = [
      ...new Set(
        this.sourceList
          .filter((source: any) => source.checked)
          .map((source: any) => source.base_lead_source_id)
      )
    ];

    let checkedSource: any = []
    checkedSource = this.sourceList
      .filter((source: any) => source.checked)
      .map((source: any) => source.id);

    let checkedSubSource: any = []
    checkedSubSource = this.sourceList
      .flatMap((source: any) => source.lead_sub_sources)
      .filter((subSource: any) => subSource.checked)
      .map((subSource: any) => subSource.id);

    let checkedUsers: any = []
    checkedUsers = this.userData.flatMap((outlet: any) => outlet.Users)
      .filter((user: any) => user.checked)
      .map((user: any) => user.id);

    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.stage_id": this.stageIds
    }

    let groupBy: any = ["parentDealer"]

    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      groupBy.push("outlet")
    } else {
      if (this.roleId == 9) {
        groupBy.push("outlet")
      }
    }
    request["groupby"] = groupBy;

    if (checkedCategories.length > 0) {
      request["product_details.product_category_id"] = checkedCategories;
    }
    if (checkedModels.length > 0) {
      request["product_details.product_model_id"] = checkedModels;
    }
    if (checkedBaseLeadSource.length > 0) {
      // request["base_lead_source_id"] = checkedBaseLeadSource;
    }
    if (checkedSource.length > 0) {
      request["lead_source_id"] = checkedSource;
    }
    if (checkedSubSource.length > 0) {
      request["lead_sub_source_id"] = checkedSubSource;
    }
    if (checkedUsers.length > 0) {
      request["current_stage.assign_to"] = checkedUsers;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getParentDealerChartCount(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.chartsData = [];
        this.regionData = [];
        if (responseData.data.currentData.length > 0) {
          this.regionData = responseData.data.currentData
          setTimeout(() => {
            this.onPDChart();
          }, 100)
        }
      }
    });
  }

  getParentDealerTableData() {
    let checkedDealer: any = [];
    checkedDealer = this.dealerData
      .filter((dealer: any) => dealer.checked)         // Filter checked zones
      .map((dealer: any) => dealer.parent_dealer_id);                // Map to zone IDs

    // Get checked region IDs
    let checkedOutlet: any = []
    checkedOutlet = this.dealerData
      .flatMap((dealer: any) => dealer.Outlets)        // Flatten regions
      .filter((outlet: any) => outlet.checked)     // Filter checked regions
      .map((outlet: any) => outlet.outlet_id);

    let checkedToggle: any = this.geographyToggle.find((item: any) => item.checked == true);
    // Map to area IDs
    let request: any = {
      "startDate": moment(this.startDate).format('YYYY-MM-DD'), //mandatory
      "endDate": moment(this.endDate).format('YYYY-MM-DD'), //mandatory
      "current_stage.stage_id": this.stageIds
    }
    let groupBy: any = ["parentDealer"]

    if (checkedDealer.length > 0) {
      request["outlet_details.parent_dealer_id"] = checkedDealer;
    }

    if (checkedOutlet.length > 0) {
      request["outlet_details.outlet_id"] = checkedOutlet;
      groupBy.push("outlet")
    } else {
      if (this.roleId == 9) {
        groupBy.push("outlet")
      }
    }
    request["groupby"] = groupBy;

    if (checkedToggle.id == 2) {
      request["custrequirment_priority_id"] = checkedToggle.id;
    } else {
      request["sel_priority_id"] = "current_stage.stage_id||" + checkedToggle.id;
    }
    request["is_outlet_all"] = this.isActiveOutlet ? 2 : 1;
    this.productivityService.getParentDealerChartCount(request).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.geographyStatus = [];
        if (responseData.data.currentData.length > 0) {
          responseData.data.currentData.forEach((dealer: any) => {
            if (groupBy.length == 1) {
              this.geographyStatus.push({ name: dealer.parent_dealer_name, leads: dealer.count, count: dealer.selectStageCount, percentage: dealer.selectStageCount === 0 ? 0 : ((dealer.selectStageCount / dealer.count) * 100).toFixed(2) })
            }
            if (dealer.outlets) {
              dealer.outlets.forEach((outlet: any) => {
                this.geographyStatus.push({ name: outlet.outlet_name, leads: outlet.count, count: outlet.selectStageCount, percentage: outlet.selectStageCount === 0 ? 0 : ((outlet.selectStageCount / outlet.count) * 100).toFixed(2) })
              });
            }
          })
        }
        this.geographyTotalLeads = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.leads || 0), 0) || 0;
        this.geographyTotalCounts = this.geographyStatus?.reduce((sum: any, zone: any) => sum + (zone.count || 0), 0) || 0;
        if (this.geographyTotalCounts === 0 || this.geographyTotalLeads === 0) {
          this.geographyStagePercentage = 0; // or handle it however you prefer
        } else {
          this.geographyStagePercentage = Math.round((this.geographyTotalCounts / this.geographyTotalLeads) * 100);
        }
      }
    });
  }

  getIcon(cardName: string): string {
    if (cardName.toLowerCase().includes('south')) {
      return `${this.bucketurl}/images/south.png`;
    } else if (cardName.toLowerCase().includes('west')) {
      return `${this.bucketurl}/images/west.png`;
    } else if (cardName.toLowerCase().includes('north')) {
      return `${this.bucketurl}/images/north.png`;
    } else if (cardName.toLowerCase().includes('east')) {
      return `${this.bucketurl}/images/east.png`;
    }
    // Default icon if no match found
    return `${this.bucketurl}/images/south.png`;
  }

  calculatePercentage(value: number): string {
    if (!this.totalLeads || isNaN(value) || value < 0) {
      return '0';  // Return 0 if totalLeads is 0, value is NaN, or invalid
    }
    const percentage = (value / this.totalLeads) * 100;

    const roundedPercentage = isFinite(percentage) ? percentage.toFixed(2) : '0.00';
    if (roundedPercentage === '100.00') {
      return '100';
    }
    // If the rounded percentage is '0.00', return '0'
    return roundedPercentage === '0.00' ? '0' : roundedPercentage;
  }

  // Helper function to check if an object is empty
  isEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  selectAllModelChecked: boolean = false;
  onModelCheckAll(event: any) {
    if (event.checked) {
      this.modelsData.forEach((model: any) => {
        model.checked = true
      })
      this.filteredModelData.forEach((model: any) => {
        model.checked = true
      })
      this.selectAllModelChecked = true;
    } else {
      this.modelsData.forEach((model: any) => {
        model.checked = false
      })
      this.filteredModelData.forEach((model: any) => {
        model.checked = false
      })
      this.selectAllModelChecked = false;
    }
  }

  selectAllCategoryChecked: boolean = false;
  onCategoryCheckAll(event: any) {
    if (event.checked) {
      this.categoryData.forEach((cat: any) => {
        cat.checked = true
      })
      this.selectAllCategoryChecked = true;
    } else {
      this.categoryData.forEach((cat: any) => {
        cat.checked = false
      })
      this.selectAllCategoryChecked = false;
    }
  }

  filterDealerByArea() {
    // if (this.roleId != 8 || this.roleId != 9) {
    //   let checkedDealer: any = [];
    //   checkedDealer = this.dealerData
    //     .filter((dealer: any) => dealer.checked)
    //     .map((dealer: any) => dealer.parent_dealer_id);

    //   let checkedAreas = [];
    //   checkedAreas = this.dropdownData
    //     .flatMap((zone: any) => zone.Regions)        // Flatten regions
    //     .flatMap((region: any) => region.Areas)      // Flatten areas
    //     .filter((area: any) => area.checked)         // Filter checked areas
    //     .map((area: any) => area.area_id);

    //   let checkedOutlet: any = []
    //   checkedOutlet = this.dealerData
    //     .flatMap((dealer: any) => dealer.Outlets)
    //     .filter((outlet: any) => outlet.checked)
    //     .map((outlet: any) => outlet.outlet_id);

    //   this.dealerData = checkedAreas.length === 0
    //     ? this.dropdownData.flatMap((zone: any) =>
    //       zone.Regions.flatMap((region: any) =>
    //         region.Areas.flatMap((area: any) =>
    //           area.ParentDealers.map((dealer: any) => ({
    //             ...dealer, // Spread existing dealer properties
    //             checked: checkedDealer.includes(dealer.parent_dealer_id), // Retain dealer checked status
    //             Outlets: dealer.Outlets.map((outlet: any) => ({
    //               ...outlet, // Spread existing outlet properties
    //               checked: checkedOutlet.includes(outlet.outlet_id) // Retain outlet checked status
    //             }))
    //           }))
    //         )
    //       )
    //     )
    //     : this.dropdownData.flatMap((zone: any) =>
    //       zone.Regions.flatMap((region: any) =>
    //         region.Areas
    //           .filter((area: any) => checkedAreas.includes(area.area_id)) // Filter areas by checked IDs
    //           .flatMap((filteredArea: any) =>
    //             filteredArea.ParentDealers.map((dealer: any) => ({
    //               ...dealer, // Spread existing dealer properties
    //               checked: checkedDealer.includes(dealer.parent_dealer_id), // Retain dealer checked status
    //               Outlets: dealer.Outlets.map((outlet: any) => ({
    //                 ...outlet, // Spread existing outlet properties
    //                 checked: checkedOutlet.includes(outlet.outlet_id) // Retain outlet checked status
    //               }))
    //             }))
    //           )
    //       )
    //     );
    //   if (checkedAreas.length == 0) {
    //     this.dealerData.forEach((dealer: any) => {
    //       dealer.checked = false;
    //       dealer.Outlets.forEach((outlet: any) => {
    //         outlet.checked = false;
    //       });
    //     })
    //   }
    //   this.filteredDealerData = [...this.dealerData];
    // }
  }

  isActiveOutlet: boolean = false;
  outletToggle(event: any) {
    this.isActiveOutlet = event.checked;
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    filterObject.isActiveOutlet = this.isActiveOutlet;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject));
    this.getGeographyList();
    this.getStageWiseCounts();
    this.callApiOnCheck();
    if (this.roleId == 8 || this.roleId == 5 || this.roleId == 10 || this.roleId == 9) {
      this.getDealerOutletList();
    }
    this.getUserList()
  }

  onUserChart() {
    this.isGeography = true;
    let isEveryUser: boolean = this.regionData.every((object: any) => {
      return !object.users || object.users.length === 0;
    });

    if (isEveryUser) {
      const outletLabels = this.regionData.map((outlet: any) => outlet.outlet_name);
      const outletCounts = this.regionData.map((outlet: any) => outlet.count);
      const totalCount = outletCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);


      const chartData = {
        data: {
          labels: outletLabels,  // Zone names as labels
          datasets: [
            {
              data: outletCounts,  // Zone counts
              backgroundColor: [
                // Original colors
                "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                // First additional set
                "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                // New additional colors
                "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                // Additional colors to reach 40
                "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
              ],
              // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
            }
          ]
        },
        options: {
          title: 'Enquiries' + ' - ' + totalCount,
          subText1: '',
          subText2: '',
          cutout: '28%',
          plugins: {
            datalabels: {
              color: '#fff',
              display: true,
              formatter: function (value: any, context: any) {
                // Calculate percentage
                const total = context.chart._metasets[context.datasetIndex].total;
                const percentage = ((value / total) * 100).toFixed(0);

                // Return count and percentage on different lines
                return `${value}\n ${percentage}%`;
              },
              font: {
                size: 9
              },
              anchor: 'end',
              align: 'start'
            },
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                text: 'Zones'
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false
        }
      };

      this.chartsData.push(chartData);

    } else {

      this.regionData.forEach((dealerObj: any) => {
        const outletName = dealerObj.outlet_name;
        const dealerCount = dealerObj.count;

        if (dealerObj.users && dealerObj.users.length > 0) {
          dealerObj.users.forEach((userObj: any) => {
            const userName = userObj.name;
            const userCount = userObj.count;

            let filteredDataNoArea = dealerObj.users
            if (filteredDataNoArea.length != 0) {

              const userLabels = filteredDataNoArea.map((user: any) => user.name);
              const userCounts = filteredDataNoArea.map((user: any) => user.count);

              const chartData = {
                zone: outletName?.toLowerCase(),
                region: userName?.toLowerCase(),
                data: {
                  labels: userLabels,  // Region names as labels
                  datasets: [
                    {
                      data: userCounts,  // Region counts
                      backgroundColor: [
                        // Original colors
                        "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                        // First additional set
                        "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                        // New additional colors
                        "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                        // Additional colors to reach 40
                        "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                        "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                        "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                        "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                        "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                      ],
                      // hoverBackgroundColor: this.getRandomColors(regionLabels.length)
                    }
                  ]
                },
                options: {
                  title: `${outletName} - ${dealerCount}`,
                  subText1: '',
                  subText2: '',
                  cutout: '28%',
                  plugins: {
                    datalabels: {
                      color: '#fff',
                      display: true,
                      formatter: function (value: any, context: any) {
                        // Calculate percentage
                        const total = context.chart._metasets[context.datasetIndex].total;
                        const percentage = ((value / total) * 100).toFixed(0);

                        // Return count and percentage on different lines
                        return `${value}\n ${percentage}%`;
                      },
                      font: {
                        size: 9
                      },
                      anchor: 'end',
                      align: 'start'
                    },
                    legend: {
                      display: true,
                      labels: {
                        usePointStyle: true,
                        text: 'Zones'
                      }
                    }
                  },
                  responsive: true,
                  maintainAspectRatio: false
                }
              };
              let filteredData: any = []

              filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone && item?.zone?.toLowerCase() == chartData?.zone)
              if (filteredData.length == 0) {
                this.chartsData.push(chartData);
              }

            }

          });
        } else {

          let filteredDataNoOutlets = this.regionData.filter((item: any) => {
            return item?.outlets && item?.outlets?.length == 0;
          });
          const dealerLabels = filteredDataNoOutlets.map((dealer: any) => dealer.outlet_name);
          const dealerCounts = filteredDataNoOutlets.map((dealer: any) => dealer.count);
          const totalCount = dealerCounts.reduce((accumulator: any, currentValue: any) => accumulator + currentValue, 0);

          const chartData = {
            zone: 'remaining-zones',
            data: {
              labels: dealerLabels,  // Zone names as labels
              datasets: [
                {
                  data: dealerCounts,  // Zone counts
                  backgroundColor: [
                    // Original colors
                    "#165DFF", "#14C9C9", "#F7BA1E", "#D60ED6", "#8B92F4", "#8D8D8D",
                    // First additional set
                    "#FF5733", "#28A745", "#FFC107", "#17A2B8", "#6F42C1", "#20C997",
                    // New additional colors
                    "#E83E8C", "#FD7E14", "#DC3545", "#6610F2", "#003366",
                    // Additional colors to reach 40
                    "#4CAF50", "#795548", "#00BCD4", "#FFEB3B", "#3F51B5",
                    "#FF9800", "#2196F3", "#E91E63", "#673AB7", "#FF5722",
                    "#9C27B0", "#F44336", "#9E9E9E", "#607D8B", "#009688",
                    "#CDDC39", "#00C853", "#FFD600", "#304FFE", "#FFAB00",
                    "#C51162", "#AA00FF", "#6200EA", "#2962FF", "#00BFA5"
                  ],
                  // hoverBackgroundColor: this.getRandomColors(zoneLabels.length)
                }
              ]
            },
            options: {
              title: 'Enquiries' + ' - ' + totalCount,
              cutout: '28%',
              plugins: {
                datalabels: {
                  color: '#fff',
                  display: true,
                  formatter: function (value: any, context: any) {
                    // Calculate percentage
                    const total = context.chart._metasets[context.datasetIndex].total;
                    const percentage = ((value / total) * 100).toFixed(0);

                    // Return count and percentage on different lines
                    return `${value}\n ${percentage}%`;
                  },
                  font: {
                    weight: 'bold',
                    size: 9
                  },
                  anchor: 'end',
                  align: 'start'
                },
                legend: {
                  display: true,
                  labels: {
                    usePointStyle: true,
                    text: 'Zones'
                  }
                }
              },
              responsive: true,
              maintainAspectRatio: false
            }
          };
          let filteredData = this.chartsData.filter((item: any) => item?.zone?.toLowerCase() == chartData?.zone)
          if (filteredData.length == 0) {
            this.chartsData.push(chartData);
          }
        }

      });
    }
  }

  selectedZonalMgrs: any = []
  onZoneSelect(item: any) {
    let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
    this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
    let event = { checked: true }
    this.onZoneCheck(event, item.zone_id)

    let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
    this.areaList = [...this.areaListAll.filter((item: any) =>
      Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
    )];
  }


  onZoneDeSelect(item: any) {
    let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id)
    this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
    if (this.regionalList.length == 0) {
      this.regionalList = this.regionalListAll
    }
    let event = { checked: false }
    const regionalUsernames = this.regionalList.map((r: any) => r.username);
    this.selectedRegionalMgrs = this.selectedRegionalMgrs.filter((mgr: any) =>
      regionalUsernames.includes(mgr.username)
    );
    if (this.regionalList.length == this.regionalListAll.length) {
      this.selectedRegionalMgrs = [];
      this.selectedAreaMgrs = [];
    }
    this.onZoneCheck(event, item.zone_id)

    let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
    this.areaList = [...this.areaListAll.filter((item: any) =>
      Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
    )];
    if (this.selectedRegionalMgrs.length == 0) {
      this.selectedAreaMgrs = []
    }
  }

  selectedRegionalMgrs: any = []
  onRegionSelect(item: any) {
    let filterUser: any = [];
    filterUser = this.regionalListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let regionIds: any = []
    if (filterUser.length > 0) {
      regionIds = filterUser[0].region_id
    }
    // Flatten selectedRegionalMgrs' region_id arrays
    let outletIdList: number[] = this.selectedRegionalMgrs
      .map((mgr: any) => mgr.outlet_id)
      .flat();
    // Get areaList based on selected region IDs
    this.areaList = [
      ...this.areaListAll.filter((area: any) =>
        Array.isArray(area.outlet_id) &&
        area.outlet_id.some((id: any) => outletIdList.includes(id))
      )
    ];

    let stateId: any = null
    // Simulate checkbox events for all selected regions
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    // Check the selected regions and their parent zones
    const zoneRegionInfoList: { zone_id: number; region_id: number, state_id: number }[] = [];

    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          if (regionIds.includes(region.region_id)) {
            zone.checked = true;
            region.checked = true;
            state.checked = true;
            zoneRegionInfoList.push({
              zone_id: zone.zone_id,
              region_id: region.region_id,
              state_id: state.state_id
            });
          }
        }
      }
    }

    console.log("zoneRegionInfoList: ", zoneRegionInfoList)
    const event = { checked: true };
    setTimeout(() => {
      zoneRegionInfoList.forEach(info => {
        this.onRegionCheck(event, info.zone_id, info.state_id, info.region_id);
      });
    }, 100);

    setTimeout(() => {
      this.updateAreaManagersList()
    }, 300);
  }


  onRegionDeSelect(item: any) {
    let filterUser: any = [];
    filterUser = this.regionalListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let regionIds: any = []
    if (filterUser.length > 0) {
      regionIds = filterUser[0].region_id
    }
    // Flatten selectedRegionalMgrs region_id arrays
    let ouletIdList: number[] = this.selectedRegionalMgrs
      .map((mgr: any) => mgr.oulet_id)
      .flat();

    // Update areaList based on currently selected regions
    this.areaList = [
      ...this.areaListAll.filter((region: any) => ouletIdList.includes(region.oulet_id))
    ];
    const regionalUsernames = this.areaList.map((r: any) => r.username);
    this.selectedAreaMgrs = this.selectedAreaMgrs.filter((mgr: any) =>
      regionalUsernames.includes(mgr.username)
    );
    const event = { checked: false };
    if (this.areaList.length == this.areaListAll.length) {
      this.selectedAreaMgrs = [];
    }
    // Loop through all region IDs and find zone-region relationships
    const zoneRegionInfoList: { zone_id: number; region_id: number, state_id: number }[] = [];

    let stateId: any = null
    // Simulate checkbox events for all selected regions
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          if (regionIds.includes(region.region_id)) {
            region.checked = false;
            // region.Areas.forEach((area: any) => {
            // area.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
            })
            // })
            const anyFiltered = state.Regions.some((region: any) => region.checked);
            if (!anyFiltered) {
              state.checked = false;
            }
            // Optional: If no regions are checked under a zone, uncheck the zone
            const anyRegionCheckedInFiltered = zone.States.some((region: any) => region.checked);
            if (!anyRegionCheckedInFiltered) {
              // zone.checked = false;
            }

            zoneRegionInfoList.push({
              zone_id: zone.zone_id,
              region_id: region.region_id,
              state_id: state.state_id
            });
          }
        }
      }
    }
    console.log("zoneRegionInfoList: ", zoneRegionInfoList)
    // Trigger uncheck logic
    setTimeout(() => {
      zoneRegionInfoList.forEach(info => {
        this.onRegionCheck(event, info.zone_id, info.state_id, info.region_id);
      });
    }, 100);

    // If no areas remain selected, call getAreaManager
    if (this.areaList.length === 0) {
      this.areaList = [...this.areaListAll]
    }
    if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length == 0) {
      this.areaList = [...this.areaListAll]
    } else if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length != 0) {
      let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
      this.areaList = [...this.areaListAll.filter((item: any) =>
        Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
      )];
    }
    setTimeout(() => {
      this.updateAreaManagersList()
    }, 300);
  }



  selectedAreaMgrs: any = []
  onAreaSelect(item: any) {
    const outletIds = item.outlet_id || [];
    const zoneRegionInfoList: { zone_id: number; region_id: number; }[] = [];
    let filterUser: any = [];
    filterUser = this.areaListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let stateId: any = null
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
    }
    console.log("outletIds: ", outletIds)
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          for (const dealer of region.ParentDealers) {
            for (const outlet of dealer.Outlets) {
              if (outletIds.includes(outlet.outlet_id)) {
                zoneRegionInfoList.push({
                  zone_id: zone.zone_id,
                  region_id: region.region_id,
                  // area_id: area.area_id
                });
                zone.checked = true;
                state.checked = true;
                region.checked = true;
                // area.checked = true;
                dealer.checked = true;
                outlet.checked = true;
              }
              // }
            }
          }
        }
      }
    }

    for (const zone of this.filteredData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          for (const dealer of region.ParentDealers) {
            for (const outlet of dealer.Outlets) {
              if (outletIds.includes(outlet.outlet_id)) {
                zone.checked = true;
                state.checked = true;
                region.checked = true;
                // area.checked = true;
                dealer.checked = true;
                outlet.checked = true;
              }
            }
            // }
          }
        }
      }
    }
    this.updateSelectAllStatus()
  }


  onAreaDeSelect(item: any) {
    const outletIds = item.outlet_id || [];
    let filterUser: any = [];
    filterUser = this.areaListAll.filter((user: any) => user.username.toLowerCase().trim() == item.username.toLowerCase().trim())
    let stateId: any = null
    let regionId: any = []
    if (filterUser.length > 0) {
      stateId = filterUser[0].state_id
      regionId = filterUser[0].region_id
    }
    for (const zone of this.dropdownData) {
      for (const state of zone.States || []) {
        for (const region of state.Regions || []) {
          // for (const area of region.Areas || []) {
          region.ParentDealers.forEach((dealer: any) => {
            dealer.Outlets.forEach((outlet: any) => {
              if (outletIds.includes(outlet.outlet_id)) {
                // area.checked = false;
                dealer.checked = false;
                outlet.checked = false;
              }
            });
          })
          // }
        }
      }
    }
      setTimeout(()=>{
      this.updateFilter();
    },100)
    this.updateSelectAllStatus();
  }



  getZonalManager() {
    this.productivityService.getGeography({ "is_outlet_all": this.isActiveOutlet ? 2 : 1 }).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        this.zonalList = responseData.data
        if (sessionStorage.getItem('filterObject')) {
          this.filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
          if (this.filterObject.zonalManagers) {
            this.selectedZonalMgrs = this.filterObject.zonalManagers || [];
          }
        }
      }
    });
  }

  regionalListAll: any = []
  getRegionalManager() {
    let zoneId: any = null;
    let regionId: any = [];
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
      }
    }
    this.productivityService.getRegionalMgrs({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {

        if (this.roleId == 2) {
          this.regionalList = responseData.data
          this.regionalListAll = [...responseData.data]
        } else if (this.roleId == 6) {
          this.regionalList = [...responseData.data.filter((item: any) => item.zone_id == zoneId)]
          this.regionalListAll = [...responseData.data.filter((item: any) => item.zone_id == zoneId)]
        } else if (this.roleId == 7) {
          this.regionalList = responseData.data.filter((item: any) =>
            Array.isArray(item.region_id) &&
            item.region_id.length === regionId.length &&
            item.region_id.every((id: any) => regionId.includes(id)) &&
            regionId.every((id: any) => item.region_id.includes(id))
          );

          this.regionalListAll = responseData.data.filter((item: any) =>
            Array.isArray(item.region_id) &&
            item.region_id.length === regionId.length &&
            item.region_id.every((id: any) => regionId.includes(id)) &&
            regionId.every((id: any) => item.region_id.includes(id))
          );

        }
        setTimeout(() => {
          if (sessionStorage.getItem('filterObject')) {
            let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
            let selectedZonalMgrs: any = []
            if (filterObject.zonalManagers) {
              selectedZonalMgrs = filterObject.zonalManagers || [];
            }
            if (selectedZonalMgrs.length > 0) {
              let zoneId: any = selectedZonalMgrs.map((item: any) => item.zone_id);
              this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
            }
            if (filterObject?.regionalManagers) {
              if (filterObject?.regionalManagers.length > 0) {
                let regionMgrs: any = filterObject?.regionalManagers || [];
                let names: any = regionMgrs.map((user: any) => user.username.toLowerCase().trim())
                let filterUser: any = [];
                filterUser = this.regionalListAll.filter((user: any) => names.includes(user.username.toLowerCase().trim()))
                this.selectedRegionalMgrs = filterUser;
              }
            }
          }
        }, 1000)
      }
    });
  }

  areaListAll: any = []
  getAreaManager() {
    let regionId: any = [];
    let zoneId: any = null
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
      }
    }
    this.productivityService.getAreaMgrs({}).subscribe((response: any) => {
      let responseData: any = response.body;
      if (responseData.responseCode == 200) {
        if (this.roleId == 2) {
          this.areaList = responseData.data;
          this.areaListAll = [...responseData.data]
          if (sessionStorage.getItem('filterObject')) {
            let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
            let selectedRegionalMgrs: any = []
            if (filterObject.regionalManagers) {
              selectedRegionalMgrs = filterObject.regionalManagers || [];
            }
            if (selectedRegionalMgrs.length > 0) {
              let regionIdList: number[] = selectedRegionalMgrs
                .map((mgr: any) => mgr.outlet_id)
                .flat();
              // Get areaList based on selected region IDs
              this.areaList = [
                ...this.areaListAll.filter((region: any) =>
                  Array.isArray(region.outlet_id) && region.outlet_id.some((id: any) => regionIdList.includes(id))
                )
              ];
            }
            if (filterObject?.areaManagers) {
              if (filterObject?.areaManagers.length > 0) {
                let areaMgrs: any = filterObject?.areaManagers || [];
                let names: any = areaMgrs.map((user: any) => user.username.toLowerCase().trim())
                let filterUser: any = [];
                filterUser = [...this.areaListAll.filter((user: any) =>
                  names.map((name: any) => name.toLowerCase().trim()).includes(user.username.toLowerCase().trim())
                )]
                this.selectedAreaMgrs = filterUser;
              }
            }
          }

        } else if (this.roleId == 6 || this.roleId == 7) {
          setTimeout(() => {
            let ids: any = [...new Set(this.regionalListAll.map((item: any) => item.outlet_id).flat())]
            this.areaList = responseData.data.filter((item: any) =>
              Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
            );
            this.areaListAll = [
              ...responseData.data.filter((item: any) =>
                Array.isArray(item.outlet_id) &&
                item.outlet_id.some((id: any) => ids.includes(id))
              )
            ];
            if (sessionStorage.getItem('filterObject')) {
              let filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
              let selectedRegionalMgrs: any = []
              if (filterObject.regionalManagers) {
                selectedRegionalMgrs = filterObject.regionalManagers || [];
              }
              if (selectedRegionalMgrs.length > 0) {
                let regionIdList: number[] = selectedRegionalMgrs
                  .map((mgr: any) => mgr.outlet_id)
                  .flat();
                // Get areaList based on selected region IDs
                this.areaList = [
                  ...this.areaListAll.filter((region: any) =>
                    Array.isArray(region.outlet_id) && region.outlet_id.some((id: any) => regionIdList.includes(id))
                  )
                ];
              }
              if (filterObject?.areaManagers) {
                if (filterObject?.areaManagers.length > 0) {
                  let areaMgrs: any = filterObject?.areaManagers || [];
                  let names: any = areaMgrs.map((user: any) => user.username.toLowerCase().trim())
                  let filterUser: any = [];
                  filterUser = [...this.areaListAll.filter((user: any) =>
                    names.map((name: any) => name.toLowerCase().trim()).includes(user.username.toLowerCase().trim())
                  )]
                  this.selectedAreaMgrs = filterUser;
                }
              }
            }

          }, 800)
        }
      }
    });
  }

  applyManagers() {
    // let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
    // let event = { checked: true }
    // this.onZoneCheck(event, zoneId)
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    filterObject.zonalManagers = this.selectedZonalMgrs;
    filterObject.regionalManagers = this.selectedRegionalMgrs;
    filterObject.areaManagers = this.selectedAreaMgrs;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject))
    setTimeout(() => {
      this.applyDateRange();
    }, 100)
  }

  filterManagerList() {
    let zoneId: any = null;
    let regionId: any = [];
    let areaId: any = [];
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        zoneId = loginResponse.data?.user?.zone_id;
        regionId = loginResponse.data?.user?.regions;
        areaId = loginResponse.data?.user?.areas;
      }
    }
    if (this.roleId == 2 && this.regionalList.length == 0 || this.roleId == 2 && this.areaList.length == 0) {
      this.regionalList = [...this.zonalList.flatMap((zone: any) => zone.Regions)]
      this.areaList = [...this.zonalList.flatMap((zone: any) => zone.Regions).flatMap((region: any) => region.Areas)]
    } else if (this.roleId == 6 && this.regionalList.length == 0 || this.roleId == 6 && this.areaList.length == 0) {
      this.regionalList = [...this.zonalList.filter((item: any) => item.zone_id == zoneId).flatMap((zone: any) => zone.Regions)]
      this.areaList = [...this.zonalList.filter((item: any) => item.zone_id == zoneId).flatMap((zone: any) => zone.Regions).flatMap((region: any) => region.Areas)]
    } else if (this.roleId == 7 && this.regionalList.length == 0 || this.roleId == 7 && this.areaList.length == 0) {
      this.areaList = [...this.zonalList.flatMap((zone: any) => zone.Regions).filter((item: any) => regionId.includes(item.region_id)).flatMap((region: any) => region.Areas)]
    }
  }
  onStateCheck(event: any, zoneId: any, stateId: any) {
    // Find the zone and region in dropdownData using id
    let zone = { ...this.dropdownData.find((z: any) => z.zone_id == zoneId) };
    let state = zone?.States.find((r: any) => r.state_id == stateId);

    // Find the zone and region in filteredData using id
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);
    let filteredState = filteredZone?.States.find((r: any) => r.state_id == stateId);

    if (event.checked) {
      // this.autoCheck(zone, region);
      state.checked = true
      filteredState.checked = true
      // Set zone checked if any region is checked in dropdownData
      const anyRegionChecked = zone.States.some((r: any) => r.checked);
      if (anyRegionChecked) {
        zone.checked = true;
      }

      // Set zone checked if any region is checked in filteredData
      const anyRegionCheckedInFiltered = filteredZone.States.some((r: any) => r.checked);
      if (anyRegionCheckedInFiltered) {
        filteredZone.checked = true;
      }
    } else {
      // Uncheck all areas within the unchecked region
      state.checked = false;
      state?.Regions.forEach((region: any) => {
        region.checked = false;
        // region?.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });

      filteredState.checked = false;
      filteredState?.Regions.forEach((region: any) => {
        region.checked = false;
        // region?.Areas.forEach((area: any) => {
        //   area.checked = false;
        region.ParentDealers.forEach((dealer: any) => {
          dealer.checked = false;
          dealer.Outlets.forEach((outlet: any) => {
            outlet.checked = false;
          });
        })
        // })
      });
    }
    this.updateSelectAllStatus()
  }

  onStateCheckAll(event: any, zoneId: any, zoneObj: any) {
    let zone = this.dropdownData.find((z: any) => z.zone_id == zoneId);
    let filteredZone = this.filteredData.find((z: any) => z.zone_id == zoneId);

    if (event.checked) {
      // this.autoCheck(zone, null)
      zone.checked = true;
      filteredZone.checked = true;
      zoneObj.States.forEach((region: any) => {
        let regionToCheck = zone.States.find((r: any) => r.state_id === region.state_id);
        let filteredRegionToCheck = filteredZone.States.find((r: any) => r.state_id === region.state_id);

        if (regionToCheck) regionToCheck.checked = true;
        if (filteredRegionToCheck) filteredRegionToCheck.checked = true;
      });
    } else {

      zoneObj.States.forEach((state: any) => {
        let regionToUncheck = zone.States.find((r: any) => r.state_id === state.state_id);
        let filteredRegionToUncheck = filteredZone.States.find((r: any) => r.state_id === state.state_id);

        if (regionToUncheck) regionToUncheck.checked = false;
        if (filteredRegionToUncheck) filteredRegionToUncheck.checked = false;
        state.Regions.forEach((region: any) => {
          region.checked = false;
          // region.Areas.forEach((area: any) => {
          //   area.checked = false;
          region.ParentDealers.forEach((dealer: any) => {
            dealer.checked = false;
            dealer.Outlets.forEach((outlet: any) => {
              outlet.checked = false;
            });
            // })
          });
        })
      });
    }
    this.updateSelectAllStatus()
  }

  showErrorForArea() {
    if (this.roleId == 2) {
      if (this.selectedZonalMgrs.length === 0 && this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager and Regional Manager first!');
        return;
      } else if (this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Regional Manager!');
      } else if (this.selectedZonalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager!');
      }
    } else if (this.roleId == 6) {
      if (this.selectedRegionalMgrs.length === 0) {
        this.toastr.error('Please select Regional Manager!');
      }
    }
  }

  showErrorForRegion() {
    if (this.roleId == 2) {
      if (this.selectedZonalMgrs.length === 0) {
        this.toastr.error('Please select Zonal Manager first!');
      }
    }
  }

  activeRequests = 0;

  startLoading() {
    this.activeRequests++;
    console.log("++++", this.activeRequests)
    this.isLoading = new BehaviorSubject<boolean>(true);
  }

  stopLoading() {
    this.activeRequests--;
    console.log("---", this.activeRequests)
    if (this.activeRequests <= 0) {
      this.isLoading = new BehaviorSubject<boolean>(false);
    }
  }

  isOneOutlet: boolean = false;
  modelSelectedAvg: 'national' | 'zonal' | 'state' | null = null;
  modelTotalLeadAvg: any = 0;
  modelTotalCountAvg: any = 0;
  modelTotalCountAvgPer: any = 0;
  modelSelectAvg(type: 'national' | 'zonal' | 'state') {
    this.modelSelectedAvg = this.modelSelectedAvg === type ? null : type;
    this.getModelTableData();
  }

  categorySelectedAvg: 'national' | 'zonal' | 'state' | null = null;
  categoryTotalLeadAvg: any = 0;
  categoryTotalCountAvg: any = 0;
  categoryTotalCountAvgPer: any = 0;
  categorySelectAvg(type: 'national' | 'zonal' | 'state') {
    this.categorySelectedAvg = this.categorySelectedAvg === type ? null : type;
    this.getCategoryTableData();
  }

  sourceSelectedAvg: 'national' | 'zonal' | 'state' | null = null;
  sourceTotalLeadAvg: any = 0;
  sourceTotalCountAvg: any = 0;
  sourceTotalCountAvgPer: any = 0;
  sourceSelectAvg(type: 'national' | 'zonal' | 'state') {
    this.sourceSelectedAvg = this.sourceSelectedAvg === type ? null : type;
    this.getSourceTableData();
  }

  geographySelectedAvg: 'national' | 'zonal' | 'state' | null = null;
  geographyTotalLeadAvg: any = 0;
  geographyTotalCountAvg: any = 0;
  geographyTotalCountAvgPer: any = 0;
  geographySelectAvg(type: 'national' | 'zonal' | 'state') {
    this.geographySelectedAvg = this.geographySelectedAvg === type ? null : type;
    this.getGeographyTableData();
  }


  get isAnyCategoryChecked(): boolean {
    return this.selectAllCategoryChecked || this.categoryData?.some((item: any) => item.checked);
  }

  get isAnyModelChecked(): boolean {
    return this.selectAllModelChecked || this.modelsData?.some((item: any) => item.checked);
  }

  get isAnySourceChecked(): boolean {
    return this.selectAllSourceChecked || this.sourceList?.some((item: any) => item.checked);
  }

  get isAnyUserChecked(): boolean {
    return this.userData?.flatMap((outlet: any) => outlet.Users || [])
      .some((user: any) => user.checked);
  }

  get isAnyGeographyChecked(): boolean {
    return this.selectAllZoneChecked || this.dropdownData?.some((zone: any) => zone.checked);
  }

  get isAnyOutletChecked(): boolean {
    return this.dealerData?.some((item: any) => item.checked);
  }

  reset() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      if (filterObject.startDate) {
        this.startDate = new Date(filterObject.startDate);
        this.endDate = new Date(filterObject.endDate);
        this.dateRange = new DateRange(this.startDate, this.endDate);
        this.selectedButton = filterObject.selectedButton;
      } else {
        this.selectThisMonth();
      }
    } else {
      this.selectThisMonth();
    }
  }

  updateAreaManagersList() {
    if (this.selectedRegionalMgrs.length != 0) {
      let outletIdList: number[] = this.selectedRegionalMgrs
        .map((mgr: any) => mgr.outlet_id)
        .flat();
      // Get areaList based on selected region IDs
      this.areaList = [
        ...this.areaListAll.filter((area: any) =>
          Array.isArray(area.outlet_id) &&
          area.outlet_id.some((id: any) => outletIdList.includes(id))
        )
      ];
    }
    if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length == 0) {
      this.areaList = [...this.areaListAll]
    } else if (this.selectedRegionalMgrs.length == 0 && this.selectedZonalMgrs.length != 0) {
      let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
      this.areaList = [...this.areaListAll.filter((item: any) =>
        Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
      )];
    }
  }

  findZoneAndStateByOutletId(data: any[], targetOutletId: number): { zone_id: number, state_id: number } | null {
    for (const zone of data) {
      for (const state of zone.States) {
        for (const region of state.Regions) {
          // for (const area of region.Areas) {
          for (const parentDealer of region.ParentDealers) {
            for (const outlet of parentDealer.Outlets) {
              if (outlet.outlet_id === targetOutletId) {
                return {
                  zone_id: zone.zone_id,
                  state_id: state.state_id
                };
              }
              // }
            }
          }
        }
      }
    }
    return null; // If no match is found
  }

  updateFilter() {
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.dropdownData.forEach((zone: any) => {
        zone.checked = false;
        zone.selectAllChecked = false;
        zone.States.forEach((state: any) => {
          state.checked = false;
          state.Regions.forEach((region: any) => {
            region.selectAllAreasChecked = false;
            region.checked = false;
            region.ParentDealers.forEach((dealer: any) => {
              dealer.checked = false;
              dealer.Outlets.forEach((outlet: any) => {
                outlet.checked = false;
              });
            })
          })
        });
      })
      setTimeout(() => {
        let zoneId: any = this.selectedZonalMgrs.map((item: any) => item.zone_id);
        this.dropdownData.forEach((zone: any) => {
          if (zoneId.includes(zone.zone_id)) {
            zone.checked = true;
          }
        });
  
        this.regionalList = [...this.regionalListAll.filter((zone: any) => zoneId.includes(zone.zone_id))];
        let ids: any = [...new Set(this.regionalList.map((item: any) => item.outlet_id).flat())]
        this.areaList = [...this.areaListAll.filter((item: any) =>
          Array.isArray(item.outlet_id) && item.outlet_id.some((id: any) => ids.includes(id))
        )];
      }, 100)
      if (this.selectedRegionalMgrs.length > 0) {
        setTimeout(() => {
          let filterUserRegion: any = [];
          filterUserRegion = this.regionalListAll.filter((user: any) =>
            this.selectedRegionalMgrs.some((mgr: any) =>
              user.username.toLowerCase().trim() === mgr.username.toLowerCase().trim()
            )
          );
  
          let regionIds: any = []
          if (filterUserRegion.length > 0) {
            regionIds = filterUserRegion.map((user: any) => user.region_id).flat();
          }
          console.log("regionIds: ", regionIds)
          let outletIdList: number[] = this.selectedRegionalMgrs
            .map((mgr: any) => mgr.outlet_id)
            .flat();
  
          this.areaList = [
            ...this.areaListAll.filter((area: any) =>
              Array.isArray(area.outlet_id) &&
              area.outlet_id.some((id: any) => outletIdList.includes(id))
            )
          ];
  
          for (const zone of this.dropdownData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                if (regionIds.includes(region.region_id)) {
                  zone.checked = true;
                  region.checked = true;
                  state.checked = true;
                }
              }
            }
          }
        }, 200)
      }
      if (this.selectedAreaMgrs.length > 0) {
        setTimeout(() => {
          const outletIds = this.selectedAreaMgrs.map((item: any) => item.outlet_id).flat() || [];
          let filterUserArea: any = [];
          filterUserArea = this.areaListAll.filter((user: any) =>
            this.selectedAreaMgrs.some((mgr: any) =>
              user.username.toLowerCase().trim() === mgr.username.toLowerCase().trim()
            )
          );
  
          for (const zone of this.dropdownData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                for (const dealer of region.ParentDealers) {
                  for (const outlet of dealer.Outlets) {
                    if (outletIds.includes(outlet.outlet_id)) {
  
                      zone.checked = true;
                      state.checked = true;
                      region.checked = true;
                      dealer.checked = true;
                      outlet.checked = true;
                    }
                  }
                }
              }
            }
          }
  
          for (const zone of this.filteredData) {
            for (const state of zone.States || []) {
              for (const region of state.Regions || []) {
                for (const dealer of region.ParentDealers) {
                  for (const outlet of dealer.Outlets) {
                    if (outletIds.includes(outlet.outlet_id)) {
                      zone.checked = true;
                      state.checked = true;
                      region.checked = true;
                      dealer.checked = true;
                      outlet.checked = true;
                    }
                  }
                }
              }
            }
          }
          this.updateSelectAllStatus()
        }, 250)
      }
       setTimeout(()=>{
              this.isLoading = new BehaviorSubject<boolean>(false);
          },300)
    }
}

